// import 'ol/ol.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {fromLonLat} from 'ol/proj';
import XYZ from 'ol/source/XYZ';
import {Group as LayerGroup, Vector as VectorLayer} from 'ol/layer';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import {Circle as CircleStyle, Style, Fill, Stroke} from 'ol/style';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';



import $ from 'jquery';

// bring in GeoJSON files
// import sgGHGData from './data/sorghumGHGSites.geo.json';

// Colors for yield polygons
var yieldColorMap = ['rgba(211,211,211,0.7)','rgba(237,248,251,0.5)','rgba(204,236,230,0.5)','rgba(153,216,201,0.5)','rgba(102,194,164,0.5)','rgba(44,162,95,0.5)','rgba(0,109,44,0.5)'];
var yieldColorList = {'N/A':'rgba(211,211,211,0.7)','0.1-5':'rgba(237,248,251,0.5)','5.1-10':'rgba(204,236,230,0.5)','10.1-15':'rgba(153,216,201,0.5)','15.1-20':'rgba(102,194,164,0.5)','20.1-25':'rgba(44,162,95,0.5)','>25':'rgba(0,109,44,0.5)'};

// function to get the color that each polygon should be
function getColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=5){indx = 1;}
    if(yieldVal>5 && yieldVal<=10){indx = 2;}
    if(yieldVal>10 && yieldVal<=15){indx = 3;}
    if(yieldVal>15 && yieldVal<=20){indx = 4;}
    if(yieldVal>20 && yieldVal<=25){indx = 5;}
    if(yieldVal>25){indx = 6;}
    return yieldColorMap[indx];
};

// Colors for AgroIBIS yield 
var yieldIBISColorMap = ['rgba(211,211,211,0.7)','rgba(237,248,251,0.5)','rgba(204,236,230,0.5)','rgba(153,216,201,0.5)','rgba(102,194,164,0.5)','rgba(44,162,95,0.5)','rgba(0,109,44,0.5)'];
var yieldIBISColorList = {'N/A':'rgba(211,211,211,0.7)','0-50':'rgba(237,248,251,0.5)','51-100':'rgba(204,236,230,0.5)','101-150':'rgba(153,216,201,0.5)','151-200':'rgba(102,194,164,0.5)','201-250':'rgba(44,162,95,0.5)','>250':'rgba(0,109,44,0.5)'};
var dmIBISColorList = {'N/A':'rgba(211,211,211,0.7)','0-5.0':'rgba(237,248,251,0.5)','5.1-10.0':'rgba(204,236,230,0.5)','10.1-15.0':'rgba(153,216,201,0.5)','15.1-20.0':'rgba(102,194,164,0.5)','20.1-25.0':'rgba(44,162,95,0.5)','>25.0':'rgba(0,109,44,0.5)'};

// function to get the color that each polygon should be
function getIBISColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=50){indx = 1;}
    if(yieldVal>50 && yieldVal<=100){indx = 2;}
    if(yieldVal>100 && yieldVal<=150){indx = 3;}
    if(yieldVal>150 && yieldVal<=200){indx = 4;}
    if(yieldVal>200 && yieldVal<=250){indx = 5;}
    if(yieldVal>250){indx = 6;}
    return yieldIBISColorMap[indx];
};

function getIBISDMColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=5){indx = 1;}
    if(yieldVal>5 && yieldVal<=10){indx = 2;}
    if(yieldVal>10 && yieldVal<=15){indx = 3;}
    if(yieldVal>15 && yieldVal<=20){indx = 4;}
    if(yieldVal>20 && yieldVal<=25){indx = 5;}
    if(yieldVal>25){indx = 6;}
    return yieldIBISColorMap[indx];
}

// Colors for GridMet TMEAN 
var tmeanGMColorMap = ['rgba(211,211,211,0.7)','rgba(254,240,1,0.5)','rgba(255,206,3,0.5)','rgba(253,154,1,0.5)','rgba(253,97,4,0.5)','rgba(255,44,5,0.5)','rgba(240,5,5,0.5)'];
var tmeanGMColorList = {'N/A':'rgba(211,211,211,0.7)','251-260K':'rgba(254,240,1,0.5)','261-270K':'rgba(255,206,3,0.5)','271-280K':'rgba(253,154,1,0.5)','281-290K':'rgba(253,97,4,0.5)','291-300K':'rgba(255,44,5,0.5)','>300K':'rgba(240,5,5,0.5)'};

// function to get the color that each polygon should be
function getTmeanGMColor(yieldVal){
	var indx = 0;
    if(yieldVal>250 && yieldVal<=260){indx = 1;}
    if(yieldVal>260 && yieldVal<=270){indx = 2;}
    if(yieldVal>270 && yieldVal<=280){indx = 3;}
    if(yieldVal>280 && yieldVal<=290){indx = 4;}
    if(yieldVal>290 && yieldVal<=300){indx = 5;}
    if(yieldVal>300){indx = 6;}
    return tmeanGMColorMap[indx];
};

// Colors for GridMet PCPN 
var pcpnGMColorMap = ['rgba(211,211,211,0.7)','rgba(255,255,224,0.5)','rgba(254,247,32,0.5)','rgba(155,250,36,0.5)','rgba(27,241,24,0.5)','rgba(49,219,146,0.5)','rgba(39,187,224,0.5)','rgba(28,111,248,0.5)','rgba(0,0,255,0.5)','rgba(0,0,139,0.5)'];
var pcpnGMColorList = {'N/A':'rgba(211,211,211,0.7)','0-10mm':'rgba(255,255,224,0.5)','10-25mm':'rgba(254,247,32,0.5)','25-50mm':'rgba(155,250,36,0.5)','50-75mm':'rgba(27,241,24,0.5)','15-100mm':'rgba(49,219,146,0.5)','100-125mm':'rgba(39,187,224,0.5)','125-150mm':'rgba(28,111,248,0.5)','150-200mm':'rgba(0,24,249,0.5)','>200mm':'rgba(0,0,139,0.5)'};

// function to get the color that each polygon should be
function getPcpnGMColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=10){indx = 1;}
    if(yieldVal>10 && yieldVal<=25){indx = 2;}
    if(yieldVal>25 && yieldVal<=50){indx = 3;}
    if(yieldVal>50 && yieldVal<=75){indx = 4;}
	if(yieldVal>75 && yieldVal<=100){indx = 5;}
	if(yieldVal>100 && yieldVal<=125){indx = 6;}
    if(yieldVal>125 && yieldVal<=150){indx = 7;}
	if(yieldVal>150 && yieldVal<=200){indx = 8;}
    if(yieldVal>200){indx = 9;}
    return pcpnGMColorMap[indx];
};

// Colors for GridMet PET 
var petGMColorMap = ['rgba(211,211,211,0.7)','rgba(254,255,213,0.5)','rgba(254,240,1,0.5)','rgba(255,235,3,0.5)','rgba(255,206,3,0.5)','rgba(255,175,100,0.5)','rgba(253,154,1,0.5)','rgba(253,97,4,0.5)','rgba(255,44,5,0.5)','rgba(240,5,5,0.5)'];
var petGMColorList = {'N/A':'rgba(211,211,211,0.7)','0-25mm':'rgba(254,255,213,0.5)','25-50mm':'rgba(254,240,1,0.5)','50-75mm':'rgba(255,235,3,0.5)','75-100mm':'rgba(255,206,3,0.5)','100-125mm':'rgba(255,175,100,0.5)','125-150mm':'rgba(253,154,1,0.5)','150-200mm':'rgba(253,97,4,0.5)','200-300mm':'rgba(255,44,5,0.5)','>300mm':'rgba(240,5,5,0.5)'};

// function to get the color that each polygon should be
function getPetGMColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=25){indx = 1;}
    if(yieldVal>25 && yieldVal<=50){indx = 2;}
    if(yieldVal>50 && yieldVal<=75){indx = 3;}
    if(yieldVal>75 && yieldVal<=100){indx = 4;}
	if(yieldVal>100 && yieldVal<=125){indx = 5;}
	if(yieldVal>125 && yieldVal<=150){indx = 6;}
    if(yieldVal>150 && yieldVal<=200){indx = 7;}
	if(yieldVal>200 && yieldVal<=300){indx = 8;}
    if(yieldVal>300){indx = 9;}
    return petGMColorMap[indx];
};

// Colors for Daycent Gridded Yield
var daycentGridYieldColorMap = ['rgba(211,211,211,0.7)','rgba(67,147,195,0.5)','rgba(252,208,161,0.5)','rgba(252,174,108,0.5)','rgba(252,140,59,0.5)','rgba(239,105,18,0.5)','rgba(217,72,1,0.5)','rgba(166,54,3,0.5)','rgba(128,38,4,0.5)'];
var daycentGridYieldColorList = {'N/A':'rgba(211,211,211,0.7)','0-2.5':'rgba(67,147,195,0.5)','2.5-5':'rgba(252,208,161,0.5)','5-7.5':'rgba(252,174,108,0.5)','7.5-10':'rgba(252,140,59,0.5)','10-12.5':'rgba(239,105,18,0.5)','12.5-15':'rgba(217,72,1,0.5)','15-17.5':'rgba(166,54,3,0.5)','>17.5':'rgba(128,38,4,0.5)'};

// function to get the color that each polygon should be
function getDaycentGridYieldColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=2.5){indx = 1;}
    if(yieldVal>2.5 && yieldVal<=5.0){indx = 2;}
    if(yieldVal>5.0 && yieldVal<=7.5){indx = 3;}
    if(yieldVal>7.5 && yieldVal<=10.0){indx = 4;}
	if(yieldVal>10.0 && yieldVal<=12.5){indx = 5;}
	if(yieldVal>12.5 && yieldVal<=15.0){indx = 6;}
    if(yieldVal>15.0 && yieldVal<=17.5){indx = 7;}
	if(yieldVal>17.5){indx = 8;}
    return daycentGridYieldColorMap[indx];
};

// Colors for GHG Abatement Cost
var ghgAbateColorMap = ['rgba(211,211,211,0.7)','rgba(67,147,195,0.5)','rgba(252,208,161,0.5)','rgba(252,174,108,0.5)','rgba(252,140,59,0.5)','rgba(217,72,1,0.5)','rgba(166,54,3,0.5)','rgba(128,38,4,0.5)'];
var ghgAbateColorList = {'N/A':'rgba(211,211,211,0.7)','0-210':'rgba(67,147,195,0.5)','210-240':'rgba(252,208,161,0.5)','240-270':'rgba(252,174,108,0.5)','270-300':'rgba(252,140,59,0.5)','300-330':'rgba(217,72,1,0.5)','330-360':'rgba(166,54,3,0.5)','>360':'rgba(128,38,4,0.5)'};

// function to get the color that each polygon should be
function ghgAbateColor(yieldVal){
	var indx = 0;
    if(yieldVal>0 && yieldVal<=210){indx = 1;}
    if(yieldVal>210 && yieldVal<=240){indx = 2;}
    if(yieldVal>240 && yieldVal<=270){indx = 3;}
    if(yieldVal>270 && yieldVal<=300){indx = 4;}
	if(yieldVal>300 && yieldVal<=330){indx = 5;}
	if(yieldVal>330 && yieldVal<=360){indx = 6;}
	if(yieldVal>360){indx = 7;}
    return ghgAbateColorMap[indx];
};

// Colors for leaching polygons
var leachColorMap = ['rgba(228,225,225,0.7)','rgba(113,171,175,0.5)','rgba(141,184,164,0.5)','rgba(166,199,150,0.5)','rgba(192,213,136,0.5)','rgba(223,236,128,0.5)','rgba(239,244,108,0.5)','rgba(251,234,92,0.5)','rgba(252,207,80,0.5)','rgba(252,179,68,0.5)','rgba(250,149,57)','rgba(246,123,46,0.5)','rgba(245,97,37,0.5)','rgba(240,62,26,0.5)','rgba(232,16,21,0.5)'];
var leachColorList = {'0-0.1':'rgba(228,225,225,0.7)','0.2-5':'rgba(113,171,175,0.5)','5.1-10':'rgba(141,184,164,0.5)','10.1-15':'rgba(166,199,150,0.5)','15.1-20':'rgba(192,213,136,0.5)','20.1-25':'rgba(223,236,128,0.5)','25.1-30':'rgba(239,244,108,0.5)','30.1-35':'rgba(251,234,92,0.5)','35.1-40':'rgba(252,207,80,0.5)','40.1-45':'rgba(252,179,68,0.5)','45.1-50':'rgba(250,149,57)','50.1-55':'rgba(246,123,46,0.5)','55.1-60':'rgba(245,97,37,0.5)','60.1-65':'rgba(240,62,26,0.5)','65.1+':'rgba(232,16,21,0.5)'};

//function to get color that each leaching polygon should be
function getLeachColor(leachVal){
	var indx = 0;
	if(leachVal>0.2 && leachVal<=5){indx = 1;}
	if(leachVal>5 && leachVal<=10){indx = 2;}
	if(leachVal>10 && leachVal<=15){indx = 3;}
	if(leachVal>15 && leachVal<=20){indx = 4;}
	if(leachVal>20 && leachVal<=25){indx = 5;}
	if(leachVal>25 && leachVal<=30){indx = 6;}
	if(leachVal>30 && leachVal<=35){indx = 7;}
	if(leachVal>35 && leachVal<=40){indx = 8;}
	if(leachVal>40 && leachVal<=45){indx = 9;}
	if(leachVal>45 && leachVal<=50){indx = 10;}
	if(leachVal>50 && leachVal<=55){indx = 11;}
	if(leachVal>55 && leachVal<=60){indx = 12;}
	if(leachVal>60 && leachVal<=65){indx = 13;}
	if(leachVal>65){indx = 14;}
	return leachColorMap[indx];
}

// Colors for soil carbon loss polygons
var carbonColorMap = ['rgba(176,23,43,0.7)','rgba(229,131,102,0.7)','rgba(247,189,162,0.7)','rgba(251,231,222,0.7)','rgba(248,243,239,0.7)','rgba(237,242,246,0.7)','rgba(212,231,238,0.7)','rgba(178,215,233,0.7)','rgba(86,159,202,0.7)','rgba(43,114,178,0.7)','rgba(17,67,120,0.7)'];
var carbonColorList = {'-4000 to -3000':'rgba(176,23,43,0.7)','-3000 to -2000':'rgba(229,131,102,0.7)','-2000 to -1000':'rgba(247,189,162,0.7)','-1000 to -500':'rgba(251,231,222,0.5)','-500 to 0':'rgba(248,243,239,0.5)','0 to 500':'rgba(237,242,246,0.5)','500 to 1000':'rgba(212,231,238,0.5)','1000 to 2000':'rgba(178,215,233,0.5)','2000 to 3000':'rgba(86,159,202,0.5)','3000 to 4000':'rgba(43,114,178,0.5)','>4000':'rgba(17,67,120,0.7)'};

//function to get color that each soil carbon loss polygon should be
function getCarbonLossColor(soilVal){
	var indx = 0;
	if(soilVal>-3000 && soilVal<=-2000){indx = 1;}
	if(soilVal>-2000 && soilVal<=-1000){indx = 2;}
	if(soilVal>-1000 && soilVal<=-500){indx = 3;}
	if(soilVal>-500 && soilVal<=0){indx = 4;}
	if(soilVal>0 && soilVal<=500){indx = 5;}
	if(soilVal>500 && soilVal<=1000){indx = 6;}
	if(soilVal>1000 && soilVal<=2000){indx = 7;}
	if(soilVal>2000 && soilVal<=3000){indx = 8;}
	if(soilVal>3000 && soilVal<=4000){indx = 9;}
	if(soilVal>4000){indx = 10;}
	return carbonColorMap[indx];
}

// Colors for acreage loss polygons
var acreageColorMap = ['rgba(221,224,233,0.7)','rgba(182,212,193,0.7)','rgba(141,180,155,0.7)','rgba(95,157,113,0.7)','rgba(64,128,82,0.7)','rgba(38,101,49,0.7)'];
var acreageColorList = {'< 0.05':'rgba(221,224,233,0.7)','0.05-0.10':'rgba(182,212,193,0.7)','0.11-0.50':'rgba(141,180,155,0.7)','0.51-1.00':'rgba(95,157,113,0.7)','1.01-2.00':'rgba(64,128,82,0.7)','> 2.00':'rgba(38,101,49,0.7)'};

//function to get color that each soil carbon loss polygon should be
function getAcreColor(acreVal){
	var indx = 0;
	if(acreVal>=0.05 && acreVal<=0.1){indx = 1;}
	if(acreVal>0.1 && acreVal<=0.5){indx = 2;}
	if(acreVal>0.51 && acreVal<=1){indx = 3;}
	if(acreVal>1 && acreVal<=2){indx = 4;}
	if(acreVal>2){indx = 5;}
	return acreageColorMap[indx];
}

// Colors for acreage loss polygons
var rentColorMap = ['rgba(224,185,232,0.7)','rgba(207,147,238,0.7)','rgba(178,119,231,0.7)','rgba(166,82,240,0.7)','rgba(140,54,243,0.7)','rgba(119,8,243,0.7)'];
var rentColorList = {'< 100':'rgba(224,185,232,0.7)','100.1-200.0':'rgba(207,147,238,0.7)','200.1-300.0':'rgba(178,119,231,0.7)','300.1-400.0':'rgba(166,82,240,0.7)','400.1-500.0':'rgba(140,54,243,0.7)','> 500.0':'rgba(119,8,243,0.7)'};

//function to get color that each soil carbon loss polygon should be
function getRentColor(rentVal){
	var indx = 0;
	if(rentVal>100 && rentVal<=200){indx = 1;}
	if(rentVal>200 && rentVal<=300){indx = 2;}
	if(rentVal>300 && rentVal<=400){indx = 3;}
	if(rentVal>400 && rentVal<=500){indx = 4;}
	if(rentVal>500){indx = 5;}
	return rentColorMap[indx];
}

// Colors for acreage loss polygons
var breakevenColorMap = ['rgba(199,243,245,0.7)','rgba(162,206,239,0.7)','rgba(126,178,226,0.7)','rgba(86,148,215,0.7)','rgba(82,107,199,0.7)','rgba(72,70,180,0.7)'];
var breakevenDWColorList = {'< 40':'rgba(199,243,245,0.7)','40.1-50.0':'rgba(162,206,239,0.7)','50.1-75.0':'rgba(126,178,226,0.7)','75.1-100.0':'rgba(86,148,215,0.7)','100.1-125.0':'rgba(82,107,199,0.7)','> 125.0':'rgba(72,70,180,0.7)'};
var breakevenhaColorList = {'< 200':'rgba(199,243,245,0.7)','200.1-400.0':'rgba(162,206,239,0.7)','400.1-600.0':'rgba(126,178,226,0.7)','600.1-800.0':'rgba(86,148,215,0.7)','800.1-1000.0':'rgba(82,107,199,0.7)','> 1000.0':'rgba(72,70,180,0.7)'};

//function to get color that eachpolygon should be
function getBreakevenDWColor(beVal){
	var indx = 0;
	if(beVal>40 && beVal<=50){indx = 1;}
	if(beVal>50 && beVal<=75){indx = 2;}
	if(beVal>75 && beVal<=100){indx = 3;}
	if(beVal>100 && beVal<=125){indx = 4;}
	if(beVal>125){indx = 5;}
	return breakevenColorMap[indx];
}

function getBreakevenhaColor(beVal){
	var indx = 0;
	if(beVal>200 && beVal<=400){indx = 1;}
	if(beVal>400 && beVal<=600){indx = 2;}
	if(beVal>600 && beVal<=800){indx = 3;}
	if(beVal>800 && beVal<=1000){indx = 4;}
	if(beVal>1000){indx = 5;}
	return breakevenColorMap[indx];
}


// Colors for Nitrogen Leaching Corn Production and Nitrogen Application polygons
var nitrogenCornColorMap = ['rgba(255,255,255,0.2)','rgba(208,255,115,0.7)','rgba(143,240,65,0.7)','rgba(61,209,59,0.7)','rgba(46,161,144,0.7)','rgba(33,89,150,0.7)','rgba(14,17,120,0.7)'];
var ncLandColorList = {'<0.01':'rgba(255,255,255,0.3)','0.01-0.10':'rgba(208,255,115,0.7)','0.11-0.20':'rgba(143,240,65,0.7)','0.21-0.40':'rgba(61,209,59,0.7)','0.41-0.60':'rgba(46,161,144,0.7)','0.61-0.80':'rgba(33,89,150,0.7)','0.81-1.00':'rgba(14,17,120,0.7)'};
var ncApplyColorList = {'<0.01':'rgba(255,255,255,0.3)','0.01-20.00':'rgba(208,255,115,0.7)','20.01-50.00':'rgba(143,240,65,0.7)','50.01-100.00':'rgba(61,209,59,0.7)','100.01-150.00':'rgba(46,161,144,0.7)','150.01-200.00':'rgba(33,89,150,0.7)','>200.00':'rgba(14,17,120,0.7)'};


//function to get color that each soil carbon loss polygon should be
function getncLandColor(ncVal){
	var indx = 0;
	if(ncVal<0.01 && ncVal<=0.1){indx = 1;}
	if(ncVal>0.1 && ncVal<=0.2){indx = 2;}
	if(ncVal>0.2 && ncVal<=0.4){indx = 3;}
	if(ncVal>0.4 && ncVal<=0.6){indx = 4;}
	if(ncVal>0.6 && ncVal<=0.8){indx = 5;}
	if(ncVal>0.8){indx = 6;}
	return nitrogenCornColorMap[indx];
}

function getncApplyColor(ncVal){
	var indx = 0;
	if(ncVal<0.01 && ncVal<=20){indx = 1;}
	if(ncVal>20 && ncVal<=50){indx = 2;}
	if(ncVal>50 && ncVal<=100){indx = 3;}
	if(ncVal>100 && ncVal<=150){indx = 4;}
	if(ncVal>150 && ncVal<=200){indx = 5;}
	if(ncVal>200){indx = 6;}
	return nitrogenCornColorMap[indx];
}

// Colors for Permanent Cropland and Grassland polygons
var guanPermCropGrassColorMap = ['rgba(208,255,115,0.6)','rgba(61,209,59,0.6)','rgba(46,161,144,0.6)','rgba(33,89,150,0.6)','rgba(14,17,120,0.6)'];
var guanPermCropGrassColorList = {'0-0.20':'rgba(208,255,115,0.7)','0.21-0.40':'rgba(61,209,59,0.7)','0.41-0.60':'rgba(46,161,144,0.7)','0.61-0.80':'rgba(33,89,150,0.7)','0.81-1.00':'rgba(14,17,120,0.7)'};

//function to get color that each soil carbon loss polygon should be
function getPermColor(ncVal){
	var indx = 0;
	if(ncVal>0.2 && ncVal<=0.4){indx = 1;}
	if(ncVal>0.4 && ncVal<=0.6){indx = 2;}
	if(ncVal>0.6 && ncVal<=0.8){indx = 3;}
	if(ncVal>0.8){indx = 4;}
	return guanPermCropGrassColorMap[indx];
}

// Colors for Khanna GHG Emissions
var khannaGHGColorMap = ['rgba(28,67,112,0.8)','rgba(53,116,180,0.8)','rgba(84,156,200,0.8)','rgba(155,202,225,0.8)','rgba(208,226,236,0.8)','rgba(242,242,243,0.8)','rgba(252,221,204,0.8)','rgba(243,173,142,0.8)','rgba(216,110,94,0.8)','rgba(184,45,63,0.8)','rgba(116,24,52,0.8)'];
var khannaGHGColorList = {'<-40':'rgba(28,67,112,0.7)','-40--30':'rgba(53,116,180,0.7)','-30--20':'rgba(84,156,200,0.7)','-20--10':'rgba(155,202,225,0.7)','-10-0':'rgba(208,226,236,0.7)','0':'rgba(242,242,243,0.7)','0-10':'rgba(252,221,204,0.7)','10-20':'rgba(243,173,142,0.7)','20-30':'rgba(216,110,94,0.7)','30-40':'rgba(184,45,63,0.7)','>40':'rgba(116,24,52,0.7)'};

//function to get color that each soil carbon loss polygon should be
function getKhannaGHGColor(ncVal){
	var indx = 0;
	if(ncVal>-40 && ncVal<=-30){indx = 1;}
	if(ncVal>-30 && ncVal<=-20){indx = 2;}
	if(ncVal>-20 && ncVal<=-10){indx = 3;}
	if(ncVal>-10 && ncVal<0){indx = 4;}
	if(ncVal==0){indx = 5;}
	if(ncVal>0 && ncVal<=10){indx = 6;}
	if(ncVal>10 && ncVal<=20){indx = 7;}
	if(ncVal>20 && ncVal<=30){indx = 8;}
	if(ncVal>30 && ncVal<=40){indx = 9;}
	if(ncVal>40){indx = 10;}
	return khannaGHGColorMap[indx];
}

// Colors for Khanna Biofuel Price
var khannaBiofuelPriceColorMap = ['rgba(253,245,236,1)','rgba(252,231,210,1)','rgba(252,211,171,1)','rgba(252,181,121,1)','rgba(252,151,79,1)','rgba(241,119,42,1)','rgba(217,89,25,1)','rgba(173,73,27,1)','rgba(138,59,28,1)'];
var khannaBiofuelPriceList = {'0':'rgba(253,245,236,0.8)','0.01-0.20':'rgba(252,231,210,0.8)','0.21-0.40':'rgba(252,211,171,0.8)','0.41-0.60':'rgba(252,181,121,0.8)','0.61-0.80':'rgba(252,151,79,0.8)','0.81-1.00':'rgba(241,119,42,0.8)','1.01-1.20':'rgba(217,89,25,0.8)','1.21-1.40':'rgba(173,73,27,0.8)','>1.40':'rgba(138,59,28,0.8)'};

//function to get color that each soil carbon loss polygon should be
function getKhannaBiofuelPriceColor(ncVal){
	var indx = 0;
	if(ncVal>0 && ncVal<=0.2){indx = 1;}
	if(ncVal>0.2 && ncVal<=0.4){indx = 2;}
	if(ncVal>0.4 && ncVal<=0.6){indx = 3;}
	if(ncVal>0.6 && ncVal<=0.8){indx = 4;}
	if(ncVal>0.8 && ncVal<=1.0){indx = 5;}
	if(ncVal>1 && ncVal<=1.2){indx = 6;}
	if(ncVal>1.2 && ncVal<=1.4){indx = 7;}
	if(ncVal>1.4){indx = 8;}
	return khannaBiofuelPriceColorMap[indx];
}

// Colors for Khanna Biomass Price
var khannaBiomassPriceColorMap = ['rgba(253,245,236,1)','rgba(252,231,210,1)','rgba(252,211,171,1)','rgba(252,181,121,1)','rgba(252,151,79,1)','rgba(241,119,42,1)','rgba(217,89,25,1)','rgba(173,73,27,1)','rgba(138,59,28,1)'];
var khannaBiomassPriceList = {'0':'rgba(253,245,236,0.8)','0.01-0.10':'rgba(252,231,210,0.8)','0.11-0.20':'rgba(252,211,171,0.8)','0.21-0.30':'rgba(252,181,121,0.8)','0.31-0.40':'rgba(252,151,79,0.8)','0.41-0.50':'rgba(241,119,42,0.8)','0.51-0.60':'rgba(217,89,25,0.8)','0.61-0.70':'rgba(173,73,27,0.8)','>0.70':'rgba(138,59,28,0.8)'};

//function to get color that each soil carbon loss polygon should be
function getKhannaBiomassPriceColor(ncVal){
	var indx = 0;
	if(ncVal>0 && ncVal<=0.1){indx = 1;}
	if(ncVal>0.1 && ncVal<=0.2){indx = 2;}
	if(ncVal>0.2 && ncVal<=0.3){indx = 3;}
	if(ncVal>0.3 && ncVal<=0.4){indx = 4;}
	if(ncVal>0.4 && ncVal<=0.5){indx = 5;}
	if(ncVal>0.5 && ncVal<=0.6){indx = 6;}
	if(ncVal>0.6 && ncVal<=0.7){indx = 7;}
	if(ncVal>0.7){indx = 8;}
	return khannaBiomassPriceColorMap[indx];
}

// Colors for Khanna Yield
var khannaYieldColorMap = ['rgba(253,245,236,1)','rgba(252,231,210,1)','rgba(252,211,171,1)','rgba(252,181,121,1)','rgba(252,151,79,1)','rgba(241,119,42,1)','rgba(217,89,25,1)','rgba(173,73,27,1)','rgba(138,59,28,1)'];
var khannaYieldList = {'0-1':'rgba(253,245,236,0.8)','1-2':'rgba(252,231,210,0.8)','2-3':'rgba(252,211,171,0.8)','3-5':'rgba(252,181,121,0.8)','5-10':'rgba(252,151,79,0.8)','10-15':'rgba(241,119,42,0.8)','15-20':'rgba(217,89,25,0.8)','20-25':'rgba(173,73,27,0.8)','>25':'rgba(138,59,28,0.8)'};

//function to get color that each soil carbon loss polygon should be
function getKhannaYieldColor(ncVal){
	var indx = 0;
	if(ncVal>1 && ncVal<=2){indx = 1;}
	if(ncVal>2 && ncVal<=3){indx = 2;}
	if(ncVal>3 && ncVal<=5){indx = 3;}
	if(ncVal>5 && ncVal<=10){indx = 4;}
	if(ncVal>10 && ncVal<=15){indx = 5;}
	if(ncVal>15 && ncVal<=20){indx = 6;}
	if(ncVal>20 && ncVal<=25){indx = 7;}
	if(ncVal>25){indx = 8;}
	return khannaYieldColorMap[indx];
}


// Create legend for yield data
function colorize(colorList,putId){
        var container = document.getElementById(putId);
        container.innerHTML = "";
        for(var key in colorList){
                var boxContainer = document.createElement("DIV");
                var box = document.createElement("DIV");
                var label = document.createElement("SPAN");

                label.innerHTML = " " + key;
                box.className = "box";
                box.style.backgroundColor = colorList[key];

                boxContainer.appendChild(box);
                boxContainer.appendChild(label);

                container.appendChild(boxContainer);
        }
};

const key = 'pk.eyJ1IjoibGVuc29yNzMiLCJhIjoiY2p3dGJ6ZXdkMjFjYTRicGwyMm9sMWRjMyJ9.U-KWbm7ihxkFLq1sFfCurA';

// Base Map Layer
var osm = new TileLayer({
	source: new OSM()
});

// Datasets from Yang, P., Zhao, Q., Cai, X. Dec. 10, 2019. “Land productivity and land availability for growing bioenergy crop in the Contiguous U.S. Center for Advanced Bioenergy and Bioproducts Innovation (CABBI).” University of Illinois at Urbana-Champaign. https://doi.org/10.13012/B2IDB-4584681_V1
var caiMLS1 = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/tileserver.php?/index.json?/ML_determin_S1_reduced/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-4584681_V1" target="_blank">Deterministic Marginal Land S1</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

var caiMLS2 = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/tileserver.php?/index.json?/ML_determin_S2_reduced/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-4584681_V1" target="_blank">Deterministic Marginal Land S2</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

var caiMLS3 = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/tileserver.php?/index.json?/ML_determin_S3_reduced/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-4584681_V1" target="_blank">Deterministic Marginal Land S3</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

var caiMLS4 = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/tileserver.php?/index.json?/ML_determin_S4_reduced/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-4584681_V1" target="_blank">Deterministic Marginal Land S4</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

// Datasets from Jiang, C., Guan, K., Khanna, M., Chen, L., Peng, J. July 23, 2021. “Assessing Marginal Land Availability Based on Land Use Change Information in the Contiguous United States.” Environmental Science & Technology. DOI: 10.1021/acs.est.1c02236.
var guanMLconf = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/tileserver.php?/index.json?/ML_reduced/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-6395937_V1" target="_blank">Economically Derived Marginal Land with Confidence</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

var guanMLunct = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/ML_unct_5acres/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-6395937_V1" target="_blank">Economically Derived Marginal Land with Uncertainty</a>']
    }),
	style: function(feature, resolution){
		return new Style({
			fill: new Fill({
				color: 'rgba(1,1,1,0.6)'
			})
		})
	}
});

var guanPermCrop = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/ML_perm_crop_4km/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-6395937_V1" target="_blank">Permanent Cropland</a>']
    }),
	style: function(feature, resolution){
		var cropVal = feature.get('PermCropland');
		return new Style({
			fill: new Fill({
				color: getPermColor(cropVal)
			})
		})
	}
});

var guanPermGras = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/ML_perm_grassland_4km/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-6395937_V1" target="_blank">Permanent Grassland</a>']
    }),
	style: function(feature, resolution){
		var grassVal = feature.get('PermGrassland');
		return new Style({
			fill: new Fill({
				color: getPermColor(grassVal)
			}),
		})
	}
});

var guanLandProd = new VectorTileLayer({
	declutter: true,
    source: new VectorTileSource({
        format: new MVT(),
        url: 'https://cabbitools.igb.illinois.edu/tileserver/ML_productivity/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-6395937_V1" target="_blank">Permanent Cropland</a>']
    }),
	style: function(feature, resolution){
		var prodVal = feature.get('Productivity');
		return new Style({
			fill: new Fill({
				color: getPermColor(prodVal)
			}),
		})
	}
});

// Make a Layer Group from the Cai Layers
var caiMLGroup = new LayerGroup({
	layers: [
		caiMLS1,
		caiMLS2,
		caiMLS3,
		caiMLS4
	]
});

// Make a Layer Group from the Guan Layers
var guanMLGroup = new LayerGroup({
	layers: [
		guanPermCrop,
		guanPermGras,
		guanLandProd,
		guanMLconf,
		guanMLunct
	]
});

// Nitrogen Leaching Overlays from Ferin et al, 2021
var bauNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/BAU_NLeaching_3857/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching Baseline Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfnNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFN_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFN (no additional nitrogen) Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfsNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFS_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFS Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfs1NLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFS1_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFS1 Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfscoNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFSco_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFS Corn Ethanol Only Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfscstoverNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFScstover_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFS Corn Stover Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

var rfsperenNLeach = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/RFSperennial_NLeaching/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">AgroIBIS-THMB Nitrogen Leaching RFS Perennial Scenario</a>']
	}),
	style: function(feature, resolution){
		var leachingVal = feature.get('NLeaching');
		return new Style({
			fill: new Fill({
				color: getLeachColor(leachingVal)
			})
		})
	}
});

// Make a Layer Group from the N Leaching Layers
var nLeachGroup = new LayerGroup({
	layers: [
		bauNLeach,
		rfnNLeach,
		rfsNLeach,
		rfs1NLeach,
		rfscoNLeach,
		rfscstoverNLeach,
		rfsperenNLeach
	]
});

// Layers from Khanna/DeLucia research, 2024
var miscGhgAbate = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/misc_ghgAbate_2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Miscanthus Greenhouse Gas Abatement Cost with SAF']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('Miscanthus_AbateCost');
		return new Style({
			fill: new Fill({
				color: ghgAbateColor(GHGVal)
			})
		})
	}
});

var ensorgGhgAbate = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/engSorg_ghgAbate_2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Energy Sorghum Greenhouse Gas Abatement Cost with SAF']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('EnergySorghum_AbateCost');
		return new Style({
			fill: new Fill({
				color: ghgAbateColor(GHGVal)
			})
		})
	}
});

var cornstovGhgAbate = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/cornStov_ghgAbate_2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Corn Stover Greenhouse Gas Abatement Cost with SAF']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('CornStover_AbateCost');
		return new Style({
			fill: new Fill({
				color: ghgAbateColor(GHGVal)
			})
		})
	}
});

var swgGhgAbate = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/swg_ghgAbate_2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Switchgrass Greenhouse Gas Abatement Cost with SAF']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('Switchgrass_AbateCost');
		return new Style({
			fill: new Fill({
				color: ghgAbateColor(GHGVal)
			})
		})
	}
});

// Make a Layer Group with the GHG Abatement Cost
var ghgAbateGroup = new LayerGroup({
	layers: [
		miscGhgAbate,
		ensorgGhgAbate,
		cornstovGhgAbate,
		swgGhgAbate
	]
});

// Layers from Khanna/Stan Lee research, 2022
var miscAgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_aboveground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Miscanthus Aboveground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('misc_ag');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var miscBgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_belowground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Miscanthus Belowground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('misc_bg');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var sorgAgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Sorghum_aboveground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Sorghum Aboveground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('Sor_ag');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var sorgBgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Sorghum_belowground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Sorghum Belowground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('Sorg_bg');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var stovAgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Stover_aboveground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Corn Stover Aboveground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('stover_ag');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var stovBgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Stover_belowground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Corn Stover Belowground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('stover_bg');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var swgAgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_aboveground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Switchgrass Aboveground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('swit_ag');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

var swgBgGHG = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_belowground_GHG/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['Switchgrass Belowground GHG Emissions']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('swit_bg');
		return new Style({
			fill: new Fill({
				color: getKhannaGHGColor(GHGVal)
			})
		})
	}
});

// Make a Layer Group from the GHG layers
var khannaGHGGroup = new LayerGroup({
	layers: [
		miscAgGHG,
		miscBgGHG,
		sorgAgGHG,
		sorgBgGHG,
		stovAgGHG,
		stovBgGHG,
		swgAgGHG,
		swgBgGHG
	]
});

var miscMassPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_BiomassPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Miscanthus Biomass Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('misc_bp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiomassPriceColor(GHGVal)
			})
		})
	}
});

var sorgMassPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Sorghum_BiomassPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Sorghum Biomass Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('sorg_bp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiomassPriceColor(GHGVal)
			})
		})
	}
});

var stovMassPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Stover_BiomassPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Corn Stover Biomass Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('stover_bp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiomassPriceColor(GHGVal)
			})
		})
	}
});

var swgMassPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_BiomassPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Switchgrass Biomass Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('swit_bp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiomassPriceColor(GHGVal)
			})
		})
	}
});

// Make a Layer Group from the GHG layers
var khannaBMPriceGroup = new LayerGroup({
	layers: [
		miscMassPrice,
		sorgMassPrice,
		stovMassPrice,
		swgMassPrice
	]
});

var miscFuelPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_BiofuelPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Miscanthus Biofuel Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('misc_bp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiofuelPriceColor(GHGVal)
			})
		})
	}
});

var sorgFuelPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Sorghum_BiofuelPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Sorghum Biofuel Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('sorg_bmp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiofuelPriceColor(GHGVal)
			})
		})
	}
});

var stovFuelPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Stover_BiofuelPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Corn Stover Biofuel Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('stov_bmp');
		return new Style({
			fill: new Fill({
				color: getKhannaBiofuelPriceColor(GHGVal)
			})
		})
	}
});

var swgFuelPrice = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_BiofuelPrice/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['BEPAM Switchgrass Biofuel Price']
	}),
	style: function(feature, resolution){
		var GHGVal = feature.get('biomass_price');
		return new Style({
			fill: new Fill({
				color: getKhannaBiofuelPriceColor(GHGVal)
			})
		})
	}
});

// Make a Layer Group from the GHG layers
var khannaBFPriceGroup = new LayerGroup({
	layers: [
		miscFuelPrice,
		sorgFuelPrice,
		stovFuelPrice,
		swgFuelPrice
	]
});

var miscKhannaYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_Yield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent County Miscanthus Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('misc_yield');
		return new Style({
			fill: new Fill({
				color: getKhannaYieldColor(yieldVal)
			})
		})
	}
});

var sorgKhannaYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Sorghum_Yield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous'
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('sorg_yield');
		return new Style({
			fill: new Fill({
				color: getKhannaYieldColor(yieldVal)
			})
		})
	}
});

var stovKhannaYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Stover_Yield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous'
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('stover_yield');
		return new Style({
			fill: new Fill({
				color: getKhannaYieldColor(yieldVal)
			})
		})
	}
});

var swgKhannaYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_Yield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous'
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('swit_yield');
		return new Style({
			fill: new Fill({
				color: getKhannaYieldColor(yieldVal)
			})
		})
	}
});

// Make a Layer Group from the GHG layers
var khannaYieldGroup = new LayerGroup({
	layers: [
		miscKhannaYield,
		sorgKhannaYield,
		stovKhannaYield,
		swgKhannaYield
	]
});

var miscDaycentYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/miscYield_daycent2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Gridded Miscanthus Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('MiscYield');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldVal)
			})
		})
	}
});

var swgDaycentYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/swgYield_daycent2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Gridded Switchgrass Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('SwgYield');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldVal)
			})
		})
	}
});

var eSorgDaycentYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/eSorgYield_daycent2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Gridded Energy Sorghum Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('ESorgYield');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldVal)
			})
		})
	}
});

var cStovDaycentYield = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/cStovYield_daycent2024/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Gridded Corn Stover Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldVal = feature.get('cstovYield');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldVal)
			})
		})
	}
});

// Make a Layer Group from the GHG layers
var dayCentGridYieldGroup = new LayerGroup({
	layers: [
		miscDaycentYield,
		swgDaycentYield,
		eSorgDaycentYield,
		cStovDaycentYield
	]
});

// DayCent Yield by CRD
var msCRP = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/miscanthusCRP_DayCentYield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent CRP Miscanthus Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldAmount = feature.get('Miscanthus_crp_county_20200110.csv.MATURE_YIELD');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var msCrop = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/miscanthusCropland_DayCentYield/{z}/{x}/{y}.pbf',
		crossOrigin: 'anonymous',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Cropland Miscanthus Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldAmount = feature.get('Miscanthus_cropland_county_20200110.csv.MATURE_YIELD');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var swCRP = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/switchgrassCRP_DayCentYield/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent CRP Switchgrass Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldAmount = feature.get('Switchgrass_crp_county_20200117.csv.MATURE_YIELD');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var swCrop = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/switchgrassCropland_DayCentYield/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://uofi.box.com/s/mzhzl4heasmkf9kxwt3onnn9gen8vj0z" target="_blank">DayCent Cropland Switchgrass Yield</a>']
	}),
	style: function(feature, resolution){
		var yieldAmount = feature.get('Switchgrass_cropland_county_20200117.csv.MATURE_YIELD');
		return new Style({
			fill: new Fill({
				color: getDaycentGridYieldColor(yieldAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

// Make a Layer Group from the Yield Datasets
var yieldGroup = new LayerGroup({
	layers: [
		msCRP,
		msCrop,
		swCRP,
		swCrop
	]
});

// DayCent soil carbon loss by county
var sclCRP = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_SoilCarbonLoss_20230606/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">DayCent Soil Carbon Loss on CRP Land (2016-20230)</a>']
	}),
	style: function(feature, resolution){
		var lossAmount = feature.get('soilCloss_CRP');
		return new Style({
			fill: new Fill({
				color: getCarbonLossColor(lossAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var sclMISC = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Miscanthus_SoilCarbonLoss/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">DayCent Soil Carbon Loss for Miscanthus (2016-20230)</a>']
	}),
	style: function(feature, resolution){
		var lossAmount = feature.get('AnnualSoilCarbonLoss_misc_20210323.csv.soil_carbon_loss_annual(kg CO2-equiv/ha-1 yr-1)');
		return new Style({
			fill: new Fill({
				color: getCarbonLossColor(lossAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var sclSG = new VectorTileLayer({
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/Switchgrass_SoilCarbonLoss/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">DayCent Soil Carbon Loss for Switchgrass (2016-20230)</a>']
	}),
	style: function(feature, resolution){
		var lossAmount = feature.get('AnnualSoilCarbonLoss_sg_20210323.csv.soil_carbon_loss_annual(kg CO2-equiv/ha-1 yr-1)');
		return new Style({
			fill: new Fill({
				color: getCarbonLossColor(lossAmount)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});


// Make a Layer Group from the Soil Carbon Loss Datasets
var sclGroup = new LayerGroup({
	layers: [
		sclCRP,
		sclMISC,
		sclSG
	]
});

// CRP Acreage and Rent Payment
var crpAcre = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_RentAcreage/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">Land enrolled in CRP (2016)</a>']
	}),
	style: function(feature, resolution){
		var acreage = feature.get('CRPContracts_20210323.csv.CRP Acreage');
		return new Style({
			fill: new Fill({
				color: getAcreColor(acreage)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var crpRent = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_RentAcreage/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">CRP Annual Land Rental Payment (2016)</a>']
	}),
	style: function(feature, resolution){
		var rent = feature.get('CRPContracts_20210323.csv.Average Rent');
		return new Style({
			fill: new Fill({
				color: getRentColor(rent)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

// CRP Breakeven Cost
var crpBkenDWMsc = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_Breakeven/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">BEPAM Miscanthus Breakeven Cost By Dry Weight</a>']
	}),
	style: function(feature, resolution){
		var beCost = feature.get('BreakevenCost_20210323.csv.Miscanthus_Breakeven_DW');
		return new Style({
			fill: new Fill({
				color: getBreakevenDWColor(beCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var crpBkenDWSg = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_Breakeven/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">BEPAM Switchgrass Breakeven Cost By Dry Weight</a>']
	}),
	style: function(feature, resolution){
		var beCost = feature.get('BreakevenCost_20210323.csv.Switchgrass_Breakeven_DW');
		return new Style({
			fill: new Fill({
				color: getBreakevenDWColor(beCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var crpBkenhaMsc = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_Breakeven/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">BEPAM Miscanthus Breakeven Cost By Hectare</a>']
	}),
	style: function(feature, resolution){
		var beCost = feature.get('BreakevenCost_20210323.csv.Miscanthus_Breakeven_ha');
		return new Style({
			fill: new Fill({
				color: getBreakevenhaColor(beCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var crpBkenhaSg = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CRP_Breakeven/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-2224392_V2" target="_blank">BEPAM Switchgrass Breakeven Cost By Hectare</a>']
	}),
	style: function(feature, resolution){
		var beCost = feature.get('BreakevenCost_20210323.csv.Switchgrass_Breakeven_ha');
		return new Style({
			fill: new Fill({
				color: getBreakevenhaColor(beCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

// Make a Layer Group from the Soil Carbon Loss Datasets
var breakevenGroup = new LayerGroup({
	layers: [
		crpBkenDWMsc,
		crpBkenDWSg,
		crpBkenhaMsc,
		crpBkenhaSg
	]
});

// Nitrogen Leaching BEPAM Land under corn production
var cpRFS1 = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CornLandProductionArea/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Corn Production using RFS1 Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_CornProductionLandArea_forMapper.csv.RFS1');
		return new Style({
			fill: new Fill({
				color: getncLandColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var cpRFS = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CornLandProductionArea/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Corn Production using RFS Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_CornProductionLandArea_forMapper.csv.RFS');
		return new Style({
			fill: new Fill({
				color: getncLandColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var cpRFSCO = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CornLandProductionArea/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Corn Production using RFS Corn Ethanol Only Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_CornProductionLandArea_forMapper.csv.RFSco');
		return new Style({
			fill: new Fill({
				color: getncLandColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var cpRFScstover = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CornLandProductionArea/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Corn Production using RFS Corn Stover Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_CornProductionLandArea_forMapper.csv.RFScstover');
		return new Style({
			fill: new Fill({
				color: getncLandColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var cpRFSperen = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/CornLandProductionArea/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Corn Production using RFS Perennial Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_CornProductionLandArea_forMapper.csv.RFSperennial');
		return new Style({
			fill: new Fill({
				color: getncLandColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

// Make a Layer Group from the Soil Carbon Loss Datasets
var cornProdGroup = new LayerGroup({
	layers: [
		cpRFS1,
		cpRFS,
		cpRFSCO,
		cpRFScstover,
		cpRFSperen
	]
});

// Nitrogen Leaching BEPAM Land under corn production
var naRFS1 = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/TotalNitrogenApplication/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Total Nitrogen Application using RFS1 Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_TotalNitrogenApplication_forMapper.csv.RFS1');
		return new Style({
			fill: new Fill({
				color: getncApplyColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var naRFS = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/TotalNitrogenApplication/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Total Nitrogen Application using RFS Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_TotalNitrogenApplication_forMapper.csv.RFS');
		return new Style({
			fill: new Fill({
				color: getncApplyColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var naRFSCO = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/TotalNitrogenApplication/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Total Nitrogen Application using RFS Corn Ethanol Only Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_TotalNitrogenApplication_forMapper.csv.RFSco');
		return new Style({
			fill: new Fill({
				color: getncApplyColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var naRFScstover = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/TotalNitrogenApplication/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Total Nitrogen Application using RFS Corn Stover Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_TotalNitrogenApplication_forMapper.csv.RFScstover');
		return new Style({
			fill: new Fill({
				color: getncApplyColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

var naRFSperen = new VectorTileLayer({
	declutter: true,
	source: new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/TotalNitrogenApplication/{z}/{x}/{y}.pbf',
		attributions: ['<a href="https://doi.org/10.13012/B2IDB-3388479_V1" target="_blank">BEPAM Total Nitrogen Application using RFS Perennial Scenario</a>']
	}),
	style: function(feature, resolution){
		var cpCost = feature.get('BEPAM_TotalNitrogenApplication_forMapper.csv.RFSperennial');
		return new Style({
			fill: new Fill({
				color: getncApplyColor(cpCost)
			}),
			stroke: new Stroke({
				color: [169, 169, 169]
			})
		})
	}
});

// Make a Layer Group from the Soil Carbon Loss Datasets
var nitrApplyGroup = new LayerGroup({
	layers: [
		naRFS1,
		naRFS,
		naRFSCO,
		naRFScstover,
		naRFSperen
	]
});

// This is for the AgroIBIS time series
var year = 'grnYld_1990';
var resyear = 'resDMYld_1990';

// Maize Grain Dry Matter Yield
var maizeDMIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS maize yield once a year is selected.
function maizeDMIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Maize Dry Matter Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedCornGrainDMYield2/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	maizeDMIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	maizeDMIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}
// Maize Grain Yield
var maizeIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS maize yield once a year is selected.
function maizeIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Maize Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedCornGrainYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	maizeIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	maizeIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISColor(yld)
			})
		})
	});
}

// Maize Residue Dry Matter Yield
var maizeDMResIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS maize yield once a year is selected.
function maizeDMResIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Maize Dry Matter Residue Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedCornResidueDMYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	maizeDMResIBIS.setSource(newSource);
	var year = 'resDMYld_' + selYear;
	maizeDMResIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}

// Soy Grain Dry Matter Yield
var soyDMIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS soy yield once a year is selected.
function soyDMIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soybean Dry Matter Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedSoyGrainDMYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	soyDMIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	soyDMIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}
// Soy Grain Yield
var soyIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS soy yield once a year is selected.
function soyIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soy Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedSoyGrainYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	soyIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	soyIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISColor(yld)
			})
		})
	});
}

// Soy Residue Dry Matter Yield
var soyDMResIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS soy yield once a year is selected.
function soyDMResIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soy Dry Matter Residue Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedSoyResidueDMYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	soyDMResIBIS.setSource(newSource);
	var year = 'resDMYld_' + selYear;
	soyDMResIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}

// Rotation Grain Dry Matter Yield
var rotDMIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS rot yield once a year is selected.
function rotDMIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soy/Maize Rotation Dry Matter Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedRotationGrainDMYield2/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	rotDMIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	rotDMIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}
// Rotation Grain Yield
var rotIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS rotation yield once a year is selected.
function rotIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soy/Maize Rotation Grain Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedRotationGrainYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	rotIBIS.setSource(newSource);
	var year = 'grnYld_' + selYear;
	rotIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISColor(yld)
			})
		})
	});
}

// Rotation Residue Dry Matter Yield
var rotDMResIBIS = new VectorTileLayer({
	declutter: true
});

// function to create the AgroIBIS rotation yield once a year is selected.
function rotDMResIBISLayer(yr){
	var selYear = yr.toString();
	var newAttribution = 'AgroIBIS Soy/Maize Rotation Dry Matter Residue Yield ' + selYear;
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/AgroIBISExpandedRotationResidueDMYield/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	rotDMResIBIS.setSource(newSource);
	var year = 'resDMYld_' + selYear;
	rotDMResIBIS.setStyle(function(feature, resolution){
		var yld = feature.get(year);
		return new Style({
			fill: new Fill({
				color: getIBISDMColor(yld)
			})
		})
	});
}

// This is for the GridMet Climatology Layers
var tmean = 'tmean_1';

var tmeanGM = new VectorTileLayer({
	declutter: true
});

// function to create the GridMet tmean climatology once a month is selected.
function tmeanGridMetLayer(mo){
	var selMon = mo.toString();
	var newAttribution = '<a href="https://www.climatologylab.org/gridmet.html" target="_blank">GridMet Mean Temperature (K) for Month ' + selMon + '</a>';
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/GridMet_tmeanK/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	tmeanGM.setSource(newSource);
	var tmean = 'tmean_' + selMon;
	tmeanGM.setStyle(function(feature, resolution){
		var tmeanVal = feature.get(tmean);
		return new Style({
			fill: new Fill({
				color: getTmeanGMColor(tmeanVal)
			})
		})
	});
}

var pcpn = 'pcpn_1';

var pcpnGM = new VectorTileLayer({
	declutter: true
});

// function to create the GridMet pcpn climatology once a month is selected.
function pcpnGridMetLayer(mo){
	var selMon = mo.toString();
	var newAttribution = '<a href="https://www.climatologylab.org/gridmet.html" target="_blank">GridMet Mean Precipitation Accumulation for Month ' + selMon + '</a>';
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/GridMet_pcpnmm/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	pcpnGM.setSource(newSource);
	var pcpn = 'pcpn_' + selMon;
	pcpnGM.setStyle(function(feature, resolution){
		var pcpnVal = feature.get(pcpn);
		return new Style({
			fill: new Fill({
				color: getPcpnGMColor(pcpnVal)
			})
		})
	});
}

var pet = 'pet_1';

var petGM = new VectorTileLayer({
	declutter: true
});

// function to create the GridMet pcpn climatology once a month is selected.
function petGridMetLayer(mo){
	var selMon = mo.toString();
	var newAttribution = '<a href="https://www.climatologylab.org/gridmet.html" target="_blank">GridMet Mean Potential Evapotranspiration for Month ' + selMon +'</a>';
	var newSource = new VectorTileSource({
		format: new MVT(),
		url: 'https://cabbitools.igb.illinois.edu/tileserver/GridMet_pet/{z}/{x}/{y}.pbf',
		attributions: [newAttribution]
	});
	petGM.setSource(newSource);
	var pet = 'pet_' + selMon;
	petGM.setStyle(function(feature, resolution){
		var petVal = feature.get(pet);
		return new Style({
			fill: new Fill({
				color: getPetGMColor(petVal)
			})
		})
	});
}

// Make a Layer Group from the Soil Carbon Loss Datasets
var gridMetGroup = new LayerGroup({
	layers: [
		tmeanGM,
		pcpnGM,
		petGM
	]
});

var sgGHGPoints = new VectorLayer({
	source: new VectorSource({
		// url: sgGHGData,
        url: '',
		format: new GeoJSON()
	}),
	style: new Style({
		image: new CircleStyle({
			radius: 3,
			fill: new Fill({color: '#0D6C8D'}),
			stroke: new Stroke({color: '#0D6C8D', width: 1})
		})
	})
});

// Set up the map with the center near the middle of the US
var map = new Map({
	target: 'map',
	layers: [
		osm,
		yieldGroup,
		sclGroup,
		nLeachGroup,
		crpRent,
		crpAcre,
		cornProdGroup,
		nitrApplyGroup,
		breakevenGroup,
		khannaGHGGroup,
		khannaBMPriceGroup,
		khannaBFPriceGroup,
		khannaYieldGroup,
		sgGHGPoints,
		caiMLGroup,
		guanMLGroup,
		maizeIBIS,
		maizeDMIBIS,
		maizeDMResIBIS,
		soyIBIS,
		soyDMIBIS,
		soyDMResIBIS,
		rotIBIS,
		rotDMIBIS,
		rotDMResIBIS,
		gridMetGroup,
		dayCentGridYieldGroup,
		ghgAbateGroup
	],
	view: new View({
		center: fromLonLat([-98.58, 38.75]),
		zoom: 5
	})
});

// Set only the first layer of the CaiMLGroup as visible on load and the rest are hidden.
caiMLS2.setVisible(false);
caiMLS3.setVisible(false);
caiMLS4.setVisible(false);
$('#visible2').prop('disabled', true);
guanMLconf.setVisible(false);
guanMLunct.setVisible(false);
$('#visible10').prop('disabled', true);
guanPermCrop.setVisible(false);
guanPermGras.setVisible(false);
guanLandProd.setVisible(false);
$('#visible3').prop('disabled', true);
$('input[name="yieldDataLayer"]').prop('disabled', true);
msCRP.setVisible(false);
msCrop.setVisible(false);
swCRP.setVisible(false);
swCrop.setVisible(false);
$('#visible4').prop('disabled', true);
bauNLeach.setVisible(false);
rfnNLeach.setVisible(false);
rfsNLeach.setVisible(false);
rfs1NLeach.setVisible(false);
rfscoNLeach.setVisible(false);
rfscstoverNLeach.setVisible(false);
rfsperenNLeach.setVisible(false);
$('#visible5').prop('disabled', true);
sclCRP.setVisible(false);
sclMISC.setVisible(false);
sclSG.setVisible(false);
$('#visible6').prop('disabled', true);
crpRent.setVisible(false);
crpAcre.setVisible(false);
$('#visible7').prop('disabled', true);
crpBkenDWMsc.setVisible(false);
crpBkenDWSg.setVisible(false);
crpBkenhaMsc.setVisible(false);
crpBkenhaSg.setVisible(false);
$('#visible8').prop('disabled', true);
cpRFS1.setVisible(false);
cpRFS.setVisible(false);
cpRFSCO.setVisible(false);
cpRFScstover.setVisible(false);
cpRFSperen.setVisible(false);
$('#visible9').prop('disabled', true);
naRFS1.setVisible(false);
naRFS.setVisible(false);
naRFSCO.setVisible(false);
naRFScstover.setVisible(false);
naRFSperen.setVisible(false);
sgGHGPoints.setVisible(false);
$('#visible11').prop('disabled', true);
miscAgGHG.setVisible(false);
miscBgGHG.setVisible(false);
sorgAgGHG.setVisible(false);
sorgBgGHG.setVisible(false);
stovAgGHG.setVisible(false);
stovBgGHG.setVisible(false);
swgAgGHG.setVisible(false);
swgBgGHG.setVisible(false);
$('#visible12').prop('disabled', true);
miscMassPrice.setVisible(false);
sorgMassPrice.setVisible(false);
stovMassPrice.setVisible(false);
swgMassPrice.setVisible(false);
$('#visible13').prop('disabled', true);
miscKhannaYield.setVisible(false);
sorgKhannaYield.setVisible(false);
stovKhannaYield.setVisible(false);
swgKhannaYield.setVisible(false);
$('#visible14').prop('disabled', true);
miscFuelPrice.setVisible(false);
sorgFuelPrice.setVisible(false);
stovFuelPrice.setVisible(false);
swgFuelPrice.setVisible(false);
$('#visible15').prop('disabled', true);
$('#visible20').prop('disabled', true);
maizeIBIS.setVisible(false);
maizeDMIBIS.setVisible(false);
maizeDMResIBIS.setVisible(false);
soyIBIS.setVisible(false);
soyDMIBIS.setVisible(false);
soyDMResIBIS.setVisible(false);
rotIBIS.setVisible(false);
rotDMIBIS.setVisible(false);
rotDMResIBIS.setVisible(false);
$('#visible16').prop('disabled', true);
$('#visible17').prop('disabled', true);
tmeanGM.setVisible(false);
pcpnGM.setVisible(false);
petGM.setVisible(false);
$('#visible18').prop('disabled', true);
miscDaycentYield.setVisible(false);
swgDaycentYield.setVisible(false);
eSorgDaycentYield.setVisible(false);
cStovDaycentYield.setVisible(false);
$('#visible19').prop('disabled', true);
miscGhgAbate.setVisible(false);
ensorgGhgAbate.setVisible(false);
cornstovGhgAbate.setVisible(false);
swgGhgAbate.setVisible(false);

//Turn off or on marginal land layer
var margLandOff = $('input[name="margLandOn"]');
margLandOff.on("change",function(){
	caiMLS1.setVisible(false);
	caiMLS2.setVisible(false);
	caiMLS3.setVisible(false);
	caiMLS4.setVisible(false);
	guanMLconf.setVisible(false);
	guanMLunct.setVisible(false);
	$('#margLandDesc').hide();
	$('input[name="margLandLayer"]').prop('disabled', true);
	$('input[name=margLandLayer]').prop('checked',false);
	if(margLandOff.prop('checked')==true){
		$('#margLandDesc').show();
		$('input[name="margLandLayer"]').prop('disabled', false);
		var margLandValue = $('input[name="margLandLayer"]:checked').val();
		if (margLandValue == "guanML"){
			var layer2Value = $("#visible2").val();
			if (layer2Value == "CFD"){guanMLconf.setVisible(true);}
			else if (layer2Value == "UNC"){guanMLunct.setVisible(true);}
		}else{
			var layer1Value = $("#visible1").val();
			if (layer1Value == "S1"){caiMLS1.setVisible(true);}
			else if(layer1Value == "S2"){caiMLS2.setVisible(true);}
			else if(layer1Value == "S3"){caiMLS3.setVisible(true);}
			else if(layer1Value == "S4"){caiMLS4.setVisible(true);}
		}
	}
});


//Switch layers visible when marginal land option is changed
var margLandObject = $('input[name="margLandLayer"]');
margLandObject.on("change",function(){
	var margLandValue = $('input[name="margLandLayer"]:checked').val();
	caiMLS1.setVisible(false);
	caiMLS2.setVisible(false);
	caiMLS3.setVisible(false);
	caiMLS4.setVisible(false);
	guanMLconf.setVisible(false);
	guanMLunct.setVisible(false);

	if (margLandValue == "guanML"){
		$('#visible2').prop('disabled', false);
		var layer2Value = $("#visible2").val();
		if (layer2Value == "CFD"){guanMLconf.setVisible(true);}
		else if (layer2Value == "UNC"){guanMLunct.setVisible(true);}
	}else{
		var layer1Value = $("#visible1").val();
		if (layer1Value == "S1"){caiMLS1.setVisible(true);}
		else if(layer1Value == "S2"){caiMLS2.setVisible(true);}
		else if(layer1Value == "S3"){caiMLS3.setVisible(true);}
		else if(layer1Value == "S4"){caiMLS4.setVisible(true);}
	}
});

// Switch layers on change from visible1 select
var layer1Object = $("#visible1");
//var layer1Object = document.getElementById("visible1");
layer1Object.on("change",function(){
	caiMLS1.setVisible(false);
	caiMLS2.setVisible(false);
	caiMLS3.setVisible(false);
	caiMLS4.setVisible(false);

	switch(layer1Object.val()){
		case "S1":
			caiMLS1.setVisible(true);
			break;
		case "S2":
			caiMLS2.setVisible(true);
			break;
		case "S3":
			caiMLS3.setVisible(true);
			break;
		case "S4":
			caiMLS4.setVisible(true);
			break;
	}
});

// Switch layers on change from visible2 select
var layer2Object = $("#visible2");
layer2Object.on("change",function(){
	guanMLconf.setVisible(false);
	guanMLunct.setVisible(false);
	switch(layer2Object.val()){
		case "CFD":
			guanMLconf.setVisible(true);
			break;
		case "UNC":
			guanMLunct.setVisible(true);
			break;
	}
});

//Turn off or on yield layer
var yieldOff = $('input[name="yieldOn"]');
$('#yieldLegend').hide();
$('#yieldTitle').hide();
$('#ibisMaizeLegend').hide();
$('#ibisMaizeTitle').hide();
$('#ibisDMLegend').hide();
$('#ibisDMTitle').hide();
yieldOff.on("change", function(){
	$('#visible3').prop('disabled', true);
	$('#visible18').prop('disabled', true);
	$('#visible15').prop('disabled', true);
	$('#visible20').prop('disabled', true);
	$('input[name="yieldDataLayer"]').prop('disabled', true);
	$('input[name=yieldDataLayer]').prop('checked',false);
	msCRP.setVisible(false);
	msCrop.setVisible(false);
	swCRP.setVisible(false);
	swCrop.setVisible(false);
	miscDaycentYield.setVisible(false);
	swgDaycentYield.setVisible(false);
	eSorgDaycentYield.setVisible(false);
	cStovDaycentYield.setVisible(false);
	maizeIBIS.setVisible(false);
	maizeDMIBIS.setVisible(false);
	maizeDMResIBIS.setVisible(false);
	soyIBIS.setVisible(false);
	soyDMIBIS.setVisible(false);
	soyDMResIBIS.setVisible(false);
	rotIBIS.setVisible(false);
	rotDMIBIS.setVisible(false);
	rotDMResIBIS.setVisible(false);
	$('#ibisMaizeLegend').hide();
	$('#ibisMaizeTitle').hide();
	$('#ibisDMLegend').hide();
	$('#ibisDMTitle').hide();
	$('#yieldLegend').hide();
	$('#yieldTitle').hide();
	if(yieldOff.prop('checked')==true){
		$('input[name="yieldDataLayer"]').prop('disabled', false);
		var yieldValue = $('input[name="yieldDataLayer"]:checked').val();
		if(yieldValue=="dcCounty"){
			colorize(daycentGridYieldColorList,'yieldLegend');
			$('#yieldLegend').show();
			$('#yieldTitle').show();
			$('#visible3').prop('disabled', false);
			var layer3Value = $("#visible3").val();
			if(layer3Value == "msCRP"){msCRP.setVisible(true);}
			else if(layer3Value == "msCrop"){msCrop.setVisible(true);}
			else if(layer3Value == "swCRP"){swCRP.setVisible(true);}
			else if(layer3Value == "swCrop"){swCrop.setVisible(true);}
		} else if(yieldValue=="dcGrid"){
			colorize(daycentGridYieldColorList,'yieldLegend');
			$('#yieldLegend').show();
			$('#yieldTitle').show();
			$('#visible18').prop('disabled', false);
			var layer18Value = $("#visible18").val();
			if(layer18Value=="dcGridMisc"){miscDaycentYield.setVisible(true);}
			else if(layer18Value=="dcGridSg"){swgDaycentYield.setVisible(true);}
			else if(layer18Value=="dcGridEngSorg"){eSorgDaycentYield.setVisible(true);}
			else if(layer18Value=="dcGridCornStov"){cStovDaycentYield.setVisible(true);}
		} else if(yieldValue=="aiYield"){
			$('#visible15').prop('disabled', false);
			$('#visible20').prop('disabled', false);
			var layer15Value = $("#visible15").val();
			var layer20Value = $("#visible20").val();
			alert(layer20Value);
			if(layer20Value=="aiMaize"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				maizeIBISLayer(layer15Value);
				maizeIBIS.setVisible(true);
			}else if(layer20Value=="aiMaizeDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				maizeDMIBISLayer(layer15Value);
				maizeDMIBIS.setVisible(true);
			}else if(layer20Value=="aiMaizeResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				maizeDMResIBISLayer(layer15Value);
				maizeDMResIBIS.setVisible(true);
			}else if(layer20Value=="aiSoy"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				soyIBISLayer(layer15Value);
				soyIBIS.setVisible(true);
			}else if(layer20Value=="aiSoyDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				soyDMIBISLayer(layer15Value);
				soyDMIBIS.setVisible(true);
			}else if(layer20Value=="aiSoyResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				soyDMResIBISLayer(layer15Value);
				soyDMResIBIS.setVisible(true);
			}else if(layer20Value=="aiRot"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				rotIBISLayer(layer15Value);
				rotIBIS.setVisible(true);
			}else if(layer20Value=="aiRotDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				rotDMIBISLayer(layer15Value);
				rotDMIBIS.setVisible(true);
			}else if(layer20Value=="aiRotResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				rotDMResIBISLayer(layer15Value);
				rotDMResIBIS.setVisible(true);
			}
		}
	}
});

//Switch layers visible when yield option is changed
var yieldDataObject = $('input[name="yieldDataLayer"]');
yieldDataObject.on("change",function(){
	$('#visible3').prop('disabled', true);
	$('#visible18').prop('disabled', true);
	var yieldValue = $('input[name="yieldDataLayer"]:checked').val();
	msCRP.setVisible(false);
	msCrop.setVisible(false);
	swCRP.setVisible(false);
	swCrop.setVisible(false);
	miscDaycentYield.setVisible(false);
	swgDaycentYield.setVisible(false);
	eSorgDaycentYield.setVisible(false);
	cStovDaycentYield.setVisible(false);
	maizeIBIS.setVisible(false);
	maizeDMIBIS.setVisible(false);
	maizeDMResIBIS.setVisible(false);
	soyIBIS.setVisible(false);
	soyDMIBIS.setVisible(false);
	soyDMResIBIS.setVisible(false);
	rotIBIS.setVisible(false);
	rotDMIBIS.setVisible(false);
	rotDMResIBIS.setVisible(false);
	$('#ibisMaizeLegend').hide();
	$('#ibisMaizeTitle').hide();
	$('#ibisDMLegend').hide();
	$('#ibisDMTitle').hide();
	$('#yieldLegend').hide();
	$('#yieldTitle').hide();
	if (yieldValue == "dcCounty"){
		colorize(daycentGridYieldColorList,'yieldLegend');
		$('#yieldLegend').show();
		$('#yieldTitle').show();
		$('#visible3').prop('disabled', false);
		var layer3Value = $("#visible3").val();
		if(layer3Value == "msCRP"){msCRP.setVisible(true);}
		else if(layer3Value == "msCrop"){msCrop.setVisible(true);}
		else if(layer3Value == "swCRP"){swCRP.setVisible(true);}
		else if(layer3Value == "swCrop"){swCrop.setVisible(true);}
	}else if(yieldValue=="dcGrid"){
		colorize(daycentGridYieldColorList,'yieldLegend');
		$('#yieldLegend').show();
		$('#yieldTitle').show();
		$('#visible18').prop('disabled', false);
		var layer18Value = $("#visible18").val();
		if(layer18Value=="dcGridMisc"){miscDaycentYield.setVisible(true);}
		else if(layer18Value=="dcGridSg"){swgDaycentYield.setVisible(true);}
		else if(layer18Value=="dcGridEngSorg"){eSorgDaycentYield.setVisible(true);}
		else if(layer18Value=="dcGridCornStov"){cStovDaycentYield.setVisible(true);}
	} else if(yieldValue=="aiYield"){
			$('#visible15').prop('disabled', false);
			$('#visible20').prop('disabled', false);
			var layer15Value = $("#visible15").val();
			var layer20Value = $("#visible20").val();
			if(layer20Value=="aiMaize"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				maizeIBISLayer(layer15Value);
				maizeIBIS.setVisible(true);
			}else if(layer20Value=="aiMaizeDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				maizeDMIBISLayer(layer15Value);
				maizeDMIBIS.setVisible(true);
			}else if(layer20Value=="aiMaizeResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				maizeDMResIBISLayer(layer15Value);
				maizeDMResIBIS.setVisible(true);
			}else if(layer20Value=="aiSoy"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				soyIBISLayer(layer15Value);
				soyIBIS.setVisible(true);
			}else if(layer20Value=="aiSoyDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				soyDMIBISLayer(layer15Value);
				soyDMIBIS.setVisible(true);
			}else if(layer20Value=="aiSoyResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				soyDMResIBISLayer(layer15Value);
				soyDMResIBIS.setVisible(true);
			}else if(layer20Value=="aiRot"){
				$('#ibisMaizeLegend').show();
				$('#ibisMaizeTitle').show();
				colorize(yieldIBISColorList,'ibisMaizeLegend');
				rotIBISLayer(layer15Value);
				rotIBIS.setVisible(true);
			}else if(layer20Value=="aiRotDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				rotDMIBISLayer(layer15Value);
				rotDMIBIS.setVisible(true);
			}else if(layer20Value=="aiRotResDM"){
				$('#ibisDMLegend').show();
				$('#ibisDMTitle').show();
				colorize(dmIBISColorList,'ibisDMLegend');
				rotDMResIBISLayer(layer15Value);
				rotDMResIBIS.setVisible(true);
			}
	}
});

// Switch layers on change from visible3 select
var layer3Object = $("#visible3");
layer3Object.on("change",function(){
	msCRP.setVisible(false);
	msCrop.setVisible(false);
	swCRP.setVisible(false);
	swCrop.setVisible(false);

	switch(layer3Object.val()){
		case "msCRP":
			msCRP.setVisible(true);
			break;
		case "msCrop":
			msCrop.setVisible(true);
			break;
		case "swCRP":
			swCRP.setVisible(true);
			break;
		case "swCrop":
			swCrop.setVisible(true);
			break;
	}
});

// Switch layers on change from visible18 select
var layer18Object = $("#visible18");
layer18Object.on("change",function(){
	miscDaycentYield.setVisible(false);
	swgDaycentYield.setVisible(false);
	eSorgDaycentYield.setVisible(false);
	cStovDaycentYield.setVisible(false);

	switch(layer18Object.val()){
		case "dcGridMisc":
			miscDaycentYield.setVisible(true);
			break;
		case "dcGridSg":
			swgDaycentYield.setVisible(true);
			break;
		case "dcGridEngSorg":
			eSorgDaycentYield.setVisible(true);
			break;
		case "dcGridCornStov":
			cStovDaycentYield.setVisible(true);
			break;
	}
});

// Switch layers on change from visible15 select
var layer15Object = $("#visible15");
layer15Object.on("change",function(){
	maizeIBIS.setVisible(false);
	maizeDMIBIS.setVisible(false);
	maizeDMResIBIS.setVisible(false);
	soyIBIS.setVisible(false);
	soyDMIBIS.setVisible(false);
	soyDMResIBIS.setVisible(false);
	$('#ibisMaizeLegend').hide();
	$('#ibisMaizeTitle').hide();
	$('#ibisDMLegend').hide();
	$('#ibisDMTitle').hide();
	var layer20Val = $("#visible20").val();
	if(layer20Val=="aiMaize"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		maizeIBISLayer(layer15Object.val());
		maizeIBIS.setVisible(true);
	}else if(layer20Val=="aiMaizeDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		maizeDMIBISLayer(layer15Object.val());
		maizeDMIBIS.setVisible(true);
	}else if(layer20Val=="aiMaizeResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		maizeDMResIBISLayer(layer15Object.val());
		maizeDMResIBIS.setVisible(true);
	}else if(layer20Val=="aiSoy"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		soyIBISLayer(layer15Object.val());
		soyIBIS.setVisible(true);
	}else if(layer20Val=="aiSoyDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		soyDMIBISLayer(layer15Object.val());
		soyDMIBIS.setVisible(true);
	}else if(layer20Val=="aiSoyResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		soyDMResIBISLayer(layer15Object.val());
		soyDMResIBIS.setVisible(true);
	}else if(layer20Val=="aiRot"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		rotIBISLayer(layer15Object.val());
		rotIBIS.setVisible(true);
	}else if(layer20Val=="aiRotDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		rotDMIBISLayer(layer15Object.val());
		rotDMIBIS.setVisible(true);
	}else if(layer20Val=="aiRotResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		rotDMResIBISLayer(layer15Object.val());
		rotDMResIBIS.setVisible(true);
	}
});

// Switch layers on change from visible20 select (IBIS yield types)
var layer20Object = $("#visible20");
layer20Object.on("change",function(){
	maizeIBIS.setVisible(false);
	maizeDMIBIS.setVisible(false);
	maizeDMResIBIS.setVisible(false);
	soyIBIS.setVisible(false);
	soyDMIBIS.setVisible(false);
	soyDMResIBIS.setVisible(false);
	$('#ibisMaizeLegend').hide();
	$('#ibisMaizeTitle').hide();
	$('#ibisDMLegend').hide();
	$('#ibisDMTitle').hide();
	var layer20Val = $("#visible20").val();
	var layer15Val = $("#visible15").val();
	if(layer20Val=="aiMaize"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		maizeIBISLayer(layer15Val);
		maizeIBIS.setVisible(true);
	}else if(layer20Val=="aiMaizeDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		maizeDMIBISLayer(layer15Val);
		maizeDMIBIS.setVisible(true);
	}else if(layer20Val=="aiMaizeResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		maizeDMResIBISLayer(layer15Object.val());
		maizeDMResIBIS.setVisible(true);
	}else if(layer20Val="aiSoy"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		soyIBISLayer(layer15Val);
		soyIBIS.setVisible(true);
	}else if(layer20Val=="aiSoyDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		soyDMIBISLayer(layer15Val);
		soyDMIBIS.setVisible(true);
	}else if(layer20Val=="aiSoyResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		soyDMResIBISLayer(layer15Object.val());
		soyDMResIBIS.setVisible(true);
	}else if(layer20Val="aiRot"){
		$('#ibisMaizeLegend').show();
		$('#ibisMaizeTitle').show();
		colorize(yieldIBISColorList,'ibisMaizeLegend');
		rotIBISLayer(layer15Val);
		rotIBIS.setVisible(true);
	}else if(layer20Val=="aiRotDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		rotDMIBISLayer(layer15Val);
		rotDMIBIS.setVisible(true);
	}else if(layer20Val=="aiRotResDM"){
		$('#ibisDMLegend').show();
		$('#ibisDMTitle').show();
		colorize(dmIBISColorList,'ibisDMLegend');
		rotDMResIBISLayer(layer15Object.val());
		rotDMResIBIS.setVisible(true);
	}
});

//Turn off or on leaching layer
var leachOff = $('input[name="nLeachOn"]');
$('#leachLegend').hide();
$('#leachTitle').hide();
leachOff.on("change", function(){
	$('#visible4').prop('disabled', true);
	bauNLeach.setVisible(false);
	rfnNLeach.setVisible(false);
	rfsNLeach.setVisible(false);
	rfs1NLeach.setVisible(false);
	rfscoNLeach.setVisible(false);
	rfscstoverNLeach.setVisible(false);
	rfsperenNLeach.setVisible(false);
	$('#leachLegend').hide();
	$('#leachTitle').hide();
	if(leachOff.prop('checked')==true){
		colorize(leachColorList,'leachLegend');
		$('#leachLegend').show();
		$('#leachTitle').show();
		$('#visible4').prop('disabled', false);
		var layer4Value = $("#visible4").val();
		if(layer4Value == "bau"){bauNLeach.setVisible(true);}
		else if(layer4Value == "rfn"){rfnNLeach.setVisible(true);}
		else if(layer4Value == "rfs"){rfsNLeach.setVisible(true);}
		else if(layer4Value == "rfs1"){rfs1NLeach.setVisible(true);}
		else if(layer4Value == "rfsco"){rfscoNLeach.setVisible(true);}
		else if(layer4Value == "rfscstover"){rfscstoverNLeach.setVisible(true);}
		else if(layer4Value == "rfsperen"){rfsperenNLeach.setVisible(true);}
	}
});

// Switch layers on change from visible4 select
var layer4Object = $("#visible4");
layer4Object.on("change",function(){
	bauNLeach.setVisible(false);
	rfnNLeach.setVisible(false);
	rfsNLeach.setVisible(false);
	rfs1NLeach.setVisible(false);
	rfscoNLeach.setVisible(false);
	rfscstoverNLeach.setVisible(false);
	rfsperenNLeach.setVisible(false);

	switch(layer4Object.val()){
		case "bau":
			bauNLeach.setVisible(true);
			break;
		case "rfn":
			rfnNLeach.setVisible(true);
			break;
		case "rfs":
			rfsNLeach.setVisible(true);
			break;
		case "rfs1":
			rfs1NLeach.setVisible(true);
			break;
		case "rfsco":
			rfscoNLeach.setVisible(true);
			break;
		case "rfscstover":
			rfscstoverNLeach.setVisible(true);
			break;
		case "rfsperen":
			rfsperenNLeach.setVisible(true);
			break;
	}
});

//Turn off or on soil C loss layer
var sclOff = $('input[name="soilCLossOn"]');
$('#sclLegend').hide();
$('#sclTitle').hide();
sclOff.on("change", function(){
	$('#visible5').prop('disabled', true);
	sclCRP.setVisible(false);
	sclMISC.setVisible(false);
	sclSG.setVisible(false);
	$('#sclLegend').hide();
	$('#sclTitle').hide();
	if(sclOff.prop('checked')==true){
		colorize(carbonColorList,'sclLegend');
		$('#sclLegend').show();
		$('#sclTitle').show();
		$('#visible5').prop('disabled', false);
		var layer5Value = $("#visible5").val();
		if(layer5Value == "crp"){sclCRP.setVisible(true);}
		else if(layer5Value == "misc"){sclMISC.setVisible(true);}
		else if(layer5Value == "sg"){sclSG.setVisible(true);}
	}
});

// Switch layers on change from visible5 select
var layer5Object = $("#visible5");
layer5Object.on("change",function(){
	sclCRP.setVisible(false);
	sclMISC.setVisible(false);
	sclSG.setVisible(false);

	switch(layer5Object.val()){
		case "crp":
			sclCRP.setVisible(true);
			break;
		case "misc":
			sclMISC.setVisible(true);
			break;
		case "sg":
			sclSG.setVisible(true);
			break;
	}
});

//Turn off or on CRP information layer
var crpOff = $('input[name="crpInfoOn"]');
$('#crpAcreLegend').hide();
$('#crpAcreTitle').hide();
$('#crpRentLegend').hide();
$('#crpRentTitle').hide();
crpOff.on("change", function(){
	$('#visible6').prop('disabled', true);
	crpRent.setVisible(false);
	crpAcre.setVisible(false);
	$('#crpAcreLegend').hide();
	$('#crpAcreTitle').hide();
	$('#crpRentLegend').hide();
	$('#crpRentTitle').hide();
	if(crpOff.prop('checked')==true){
		colorize(acreageColorList,'crpAcreLegend');
		colorize(rentColorList,'crpRentLegend');
		$('#visible6').prop('disabled', false);
		var layer6Value = $("#visible6").val();
		if(layer6Value == "acre"){
			crpAcre.setVisible(true);
			$('#crpAcreLegend').show();
			$('#crpAcreTitle').show();
		}
		else if(layer6Value == "rent"){
			crpRent.setVisible(true);
			$('#crpRentLegend').show();
			$('#crpRentTitle').show();
		}
	}
});

// Switch layers on change from visible6 select
var layer6Object = $("#visible6");
layer6Object.on("change",function(){
	crpAcre.setVisible(false);
	crpRent.setVisible(false);
	$('#crpAcreLegend').hide();
	$('#crpAcreTitle').hide();
	$('#crpRentLegend').hide();
	$('#crpRentTitle').hide();

	switch(layer6Object.val()){
		case "acre":
			crpAcre.setVisible(true);
			$('#crpAcreLegend').show();
			$('#crpAcreTitle').show();
			break;
		case "rent":
			crpRent.setVisible(true);
			$('#crpRentLegend').show();
			$('#crpRentTitle').show();
			break;
	}
});

//Turn off or on breakeven layer
var brkevnOff = $('input[name="breakevenOn"]');
$('#brkevnLegend').hide();
$('#brkevnDwTitle').hide();
$('#brkevnhaTitle').hide();
brkevnOff.on("change", function(){
	$('#visible7').prop('disabled', true);
	crpBkenDWMsc.setVisible(false);
	crpBkenDWSg.setVisible(false);
	crpBkenhaMsc.setVisible(false);
	crpBkenhaSg.setVisible(false);
	$('#brkevnLegend').hide();
	$('#brkevnDwTitle').hide();
	$('#brkevnhaTitle').hide();
	if(brkevnOff.prop('checked')==true){
		$('#visible7').prop('disabled', false);
		var layer7Value = $("#visible7").val();
		if(layer7Value == "dwMs"){
			crpBkenDWMsc.setVisible(true);
			colorize(breakevenDWColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnDwTitle').show();
		}
		else if(layer7Value == "dwSg"){
			crpBkenDWSg.setVisible(true);
			colorize(breakevenDWColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnDwTitle').show();
		}
		else if(layer7Value == "haMs"){
			crpBkenhaMsc.setVisible(true);
			colorize(breakevenhaColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnhaTitle').show();
		}
		else if(layer7Value == "haSg"){
			crpBkenhaSg.setVisible(true);
			colorize(breakevenhaColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnhaTitle').show();
		}

	}
});

// Switch layers on change from visible5 select
var layer7Object = $("#visible7");
layer7Object.on("change",function(){
	crpBkenDWMsc.setVisible(false);
	crpBkenDWSg.setVisible(false);
	crpBkenhaMsc.setVisible(false);
	crpBkenhaSg.setVisible(false);
	$('#brkevnLegend').hide();
	$('#brkevnDwTitle').hide();
	$('#brkevnhaTitle').hide();
	switch(layer7Object.val()){
		case "dwMs":
			colorize(breakevenDWColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnDwTitle').show();
			crpBkenDWMsc.setVisible(true);
			break;
		case "dwSg":
			colorize(breakevenDWColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnDwTitle').show();
			crpBkenDWSg.setVisible(true);
			break;
		case "haMs":
			colorize(breakevenhaColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnhaTitle').show();
			crpBkenhaMsc.setVisible(true);
			break;
		case "haSg":
			colorize(breakevenhaColorList,'brkevnLegend');
			$('#brkevnLegend').show();
			$('#brkevnhaTitle').show();
			crpBkenhaSg.setVisible(true);
			break;
	}
});

//Turn off or on N. Leaching crop production layer
var cornProdOff = $('input[name="leachLandProdOn"]');
$('#cornProdLegend').hide();
$('#cornProdTitle').hide();
cornProdOff.on("change", function(){
	$('#visible8').prop('disabled', true);
	cpRFS1.setVisible(false);
	cpRFS.setVisible(false);
	cpRFSCO.setVisible(false);
	cpRFScstover.setVisible(false);
	cpRFSperen.setVisible(false);
	$('#cornProdLegend').hide();
	$('#cornProdTitle').hide();
	if(cornProdOff.prop('checked')==true){
		$('#visible8').prop('disabled', false);
		$('#cornProdLegend').show();
		$('#cornProdTitle').show();
		colorize(ncLandColorList,'cornProdLegend');
		var layer8Value = $("#visible8").val();
		if(layer8Value == "rfs1"){
			cpRFS1.setVisible(true);
		}
		else if(layer8Value == "rfs"){
			cpRFS.setVisible(true);
		}
		else if(layer8Value == "rfsco"){
			cpRFSCO.setVisible(true);
		}
		else if(layer8Value == "rfscstover"){
			cpRFScstover.setVisible(true);
		}
		else if(layer8Value == "rfsperen"){
			cpRFSperen.setVisible(true);
		}
	}
});

// Switch layers on change from visible8 select
var layer8Object = $("#visible8");
layer8Object.on("change",function(){
	cpRFS1.setVisible(false);
	cpRFS.setVisible(false);
	cpRFSCO.setVisible(false);
	cpRFScstover.setVisible(false);
	cpRFSperen.setVisible(false);
	switch(layer8Object.val()){
		case "rfs1":
			cpRFS1.setVisible(true);
			break;
		case "rfs":
			cpRFS.setVisible(true);
			break;
		case "rfsco":
			cpRFSCO.setVisible(true);
			break;
		case "rfscstover":
			cpRFScstover.setVisible(true);
			break;
		case "rfsperen":
			cpRFSperen.setVisible(true);
			break;
	}
});

//Turn off or on N. Leaching nitrogen application layer
var nitroApplyOff = $('input[name="leachNAppOn"]');
$('#nitAppLegend').hide();
$('#nitAppTitle').hide();
nitroApplyOff.on("change", function(){
	$('#visible9').prop('disabled', true);
	naRFS1.setVisible(false);
	naRFS.setVisible(false);
	naRFSCO.setVisible(false);
	naRFScstover.setVisible(false);
	naRFSperen.setVisible(false);
	$('#nitAppLegend').hide();
	$('#nitAppTitle').hide();
	if(nitroApplyOff.prop('checked')==true){
		$('#visible9').prop('disabled', false);
		$('#nitAppLegend').show();
		$('#nitAppTitle').show();
		colorize(ncApplyColorList,'nitAppLegend');
		var layer9Value = $("#visible9").val();
		if(layer9Value == "rfs1"){
			naRFS1.setVisible(true);
		}
		else if(layer9Value == "rfs"){
			naRFS.setVisible(true);
		}
		else if(layer9Value == "rfsco"){
			naRFSCO.setVisible(true);
		}
		else if(layer9Value == "rfscstover"){
			naRFScstover.setVisible(true);
		}
		else if(layer9Value == "rfsperen"){
			naRFSperen.setVisible(true);
		}
	}
});

// Switch layers on change from visible8 select
var layer9Object = $("#visible9");
layer9Object.on("change",function(){
	naRFS1.setVisible(false);
	naRFS.setVisible(false);
	naRFSCO.setVisible(false);
	naRFScstover.setVisible(false);
	naRFSperen.setVisible(false);
	switch(layer9Object.val()){
		case "rfs1":
			naRFS1.setVisible(true);
			break;
		case "rfs":
			naRFS.setVisible(true);
			break;
		case "rfsco":
			naRFSCO.setVisible(true);
			break;
		case "rfscstover":
			naRFScstover.setVisible(true);
			break;
		case "rfsperen":
			naRFSperen.setVisible(true);
			break;
	}
});

//Turn off or on Guan Land Use layer
var landUseOff = $('input[name="guanLandOn"]');
$('#guanPermLegend').hide();
$('#guanPermTitle').hide();
landUseOff.on("change", function(){
	$('#visible10').prop('disabled', true);
	guanPermCrop.setVisible(false);
	guanPermGras.setVisible(false);
	guanLandProd.setVisible(false);
	$('#guanPermLegend').hide();
	$('#guanPermTitle').hide();
	if(landUseOff.prop('checked')==true){
		$('#visible10').prop('disabled', false);
		$('#guanPermLegend').show();
		$('#guanPermTitle').show();
		colorize(guanPermCropGrassColorList,'guanPermLegend');
		var layer10Value = $("#visible10").val();
		if(layer10Value == "CROPL"){
			guanPermCrop.setVisible(true);
		}
		else if(layer10Value == "GRASSL"){
			guanPermGras.setVisible(true);
		}
		else if(layer10Value == "LANDPROD"){
			guanLandProd.setVisible(true);
		}
	}
});

// Switch layers on change from visible10 select
var layer10Object = $("#visible10");
layer10Object.on("change",function(){
	guanPermCrop.setVisible(false);
	guanPermGras.setVisible(false);
	switch(layer10Object.val()){
		case "CROPL":
			guanPermCrop.setVisible(true);
			break;
		case "GRASSL":
			guanPermGras.setVisible(true);
			break;
		case "LANDPROD":
			guanLandProd.setVisible(true);
			break;
	}
});

//Turn off or on Khanna GHG by crop layer
var khannaGHGOff = $('input[name="ghgKhannaOn"]');
$('#khannaGHGLegend').hide();
$('#khannaGHGTitle').hide();
khannaGHGOff.on("change", function(){
	$('#visible11').prop('disabled', true);
	miscAgGHG.setVisible(false);
	miscBgGHG.setVisible(false);
	sorgAgGHG.setVisible(false);
	sorgBgGHG.setVisible(false);
	stovAgGHG.setVisible(false);
	stovBgGHG.setVisible(false);
	swgAgGHG.setVisible(false);
	swgBgGHG.setVisible(false);
	$('#khannaGHGLegend').hide();
	$('#khannaGHGTitle').hide();
	if(khannaGHGOff.prop('checked')==true){
		$('#visible11').prop('disabled', false);
		$('#khannaGHGLegend').show();
		$('#khannaGHGTitle').show();
		colorize(khannaGHGColorList,'khannaGHGLegend');
		var layer11Value = $("#visible11").val();
		if(layer11Value == "miscAgGHG"){
			miscAgGHG.setVisible(true);
		}
		else if(layer11Value == "miscBgGHG"){
			miscBgGHG.setVisible(true);
		}
		else if(layer11Value == "sgAgGHG"){
			sorgAgGHG.setVisible(true);
		}
		else if(layer11Value == "sgBgGHG"){
			sorgBgGHG.setVisible(true);
		}
		else if(layer11Value == "cornstovAgGHG"){
			stovAgGHG.setVisible(true);
		}
		else if(layer11Value == "cornstovBgGHG"){
			stovBgGHG.setVisible(true);
		}
		else if(layer11Value == "swgAgGHG"){
			swgAgGHG.setVisible(true);
		}
		else if(layer11Value == "swgBgGHG"){
			swgBgGHG.setVisible(true);
		}
	}
});

// Switch layers on change from visible11 select
var layer11Object = $("#visible11");
layer11Object.on("change",function(){
	miscAgGHG.setVisible(false);
	miscBgGHG.setVisible(false);
	sorgAgGHG.setVisible(false);
	sorgBgGHG.setVisible(false);
	stovAgGHG.setVisible(false);
	stovBgGHG.setVisible(false);
	swgAgGHG.setVisible(false);
	swgBgGHG.setVisible(false);
	switch(layer11Object.val()){
		case "miscAgGHG":
			miscAgGHG.setVisible(true);
			break;
		case "miscBgGHG":
			miscBgGHG.setVisible(true);
			break;
		case "sgAgGHG":
			sorgAgGHG.setVisible(true);
			break;
		case "sgBgGHG":
			sorgBgGHG.setVisible(true);
			break;
		case "cornstovAgGHG":
			stovAgGHG.setVisible(true);
			break;
		case "cornstovBgGHG":
			stovBgGHG.setVisible(true);
			break;
		case "swgAgGHG":
			swgAgGHG.setVisible(true);
			break;
		case "swgBgGHG":
			swgBgGHG.setVisible(true);
			break;
	}
});

//Turn off or on Khanna Biomass Price by crop layer
var khannaBMPriceOff = $('input[name="biomassPriceKhannaOn"]');
$('#biomassPriceLegend').hide();
$('#biomassPriceTitle').hide();
khannaBMPriceOff.on("change", function(){
	$('#visible12').prop('disabled', true);
	miscMassPrice.setVisible(false);
	sorgMassPrice.setVisible(false);
	stovMassPrice.setVisible(false);
	swgMassPrice.setVisible(false);
	$('#biomassPriceLegend').hide();
	$('#biomassPriceTitle').hide();
	if(khannaBMPriceOff.prop('checked')==true){
		$('#visible12').prop('disabled', false);
		$('#biomassPriceLegend').show();
		$('#biomassPriceTitle').show();
		colorize(khannaBiomassPriceList,'biomassPriceLegend');
		var layer12Value = $("#visible12").val();
		if(layer12Value == "miscBMPrice"){
			miscMassPrice.setVisible(true);
		}
		else if(layer12Value == "sgBMPrice"){
			sorgMassPrice.setVisible(true);
		}
		else if(layer12Value == "cornstovBMPrice"){
			stovMassPrice.setVisible(true);
		}
		else if(layer12Value == "swgBMPrice"){
			swgMassPrice.setVisible(true);
		}
	}
});

// Switch layers on change from visible12 select
var layer12Object = $("#visible12");
layer12Object.on("change",function(){
	miscMassPrice.setVisible(false);
	sorgMassPrice.setVisible(false);
	stovMassPrice.setVisible(false);
	swgMassPrice.setVisible(false);
	switch(layer12Object.val()){
		case "miscBMPrice":
			miscMassPrice.setVisible(true);
			break;
		case "sgBMPrice":
			sorgMassPrice.setVisible(true);
			break;
		case "cornstovBMPrice":
			stovMassPrice.setVisible(true);
			break;
		case "swgBMPrice":
			swgMassPrice.setVisible(true);
			break;
	}
});

//Turn off or on Khanna Yield by crop layer
var khannaYieldOff = $('input[name="yieldKhannaOn"]');
$('#khannaYieldLegend').hide();
$('#khannaYieldTitle').hide();
khannaYieldOff.on("change", function(){
	$('#visible13').prop('disabled', true);
	miscKhannaYield.setVisible(false);
	sorgKhannaYield.setVisible(false);
	stovKhannaYield.setVisible(false);
	swgKhannaYield.setVisible(false);
	$('#khannaYieldLegend').hide();
	$('#khannaYieldTitle').hide();
	if(khannaYieldOff.prop('checked')==true){
		$('#visible13').prop('disabled', false);
		$('#khannaYieldLegend').show();
		$('#khannaYieldTitle').show();
		colorize(khannaYieldList,'khannaYieldLegend');
		var layer13Value = $("#visible13").val();
		if(layer13Value == "miscYield"){
			miscKhannaYield.setVisible(true);
		}
		else if(layer13Value == "sgYield"){
			sorgKhannaYield.setVisible(true);
		}
		else if(layer13Value == "cornstovYield"){
			stovKhannaYield.setVisible(true);
		}
		else if(layer13Value == "swgYield"){
			swgKhannaYield.setVisible(true);
		}
	}
});

// Switch layers on change from visible13 select
var layer13Object = $("#visible13");
layer13Object.on("change",function(){
	miscKhannaYield.setVisible(false);
	sorgKhannaYield.setVisible(false);
	stovKhannaYield.setVisible(false);
	swgKhannaYield.setVisible(false);
	switch(layer13Object.val()){
		case "miscYield":
			miscKhannaYield.setVisible(true);
			break;
		case "sgYield":
			sorgKhannaYield.setVisible(true);
			break;
		case "cornstovYield":
			stovKhannaYield.setVisible(true);
			break;
		case "swgYield":
			swgKhannaYield.setVisible(true);
			break;
	}
});

//Turn off or on Khanna Biofuel Price by crop layer
var khannaBFPriceOff = $('input[name="biofuelPriceKhannaOn"]');
$('#biofuelPriceLegend').hide();
$('#biofuelPriceTitle').hide();
khannaBFPriceOff.on("change", function(){
	$('#visible14').prop('disabled', true);
	miscFuelPrice.setVisible(false);
	sorgFuelPrice.setVisible(false);
	stovFuelPrice.setVisible(false);
	swgFuelPrice.setVisible(false);
	$('#biofuelPriceLegend').hide();
	$('#biofuelPriceTitle').hide();
	if(khannaBFPriceOff.prop('checked')==true){
		$('#visible14').prop('disabled', false);
		$('#biofuelPriceLegend').show();
		$('#biofuelPriceTitle').show();
		colorize(khannaBiofuelPriceList,'biofuelPriceLegend');
		var layer14Value = $("#visible14").val();
		if(layer14Value == "miscBFPrice"){
			miscFuelPrice.setVisible(true);
		}
		else if(layer14Value == "sgBFPrice"){
			sorgFuelPrice.setVisible(true);
		}
		else if(layer14Value == "cornstovBFPrice"){
			stovFuelPrice.setVisible(true);
		}
		else if(layer14Value == "swgBFPrice"){
			swgFuelPrice.setVisible(true);
		}
	}
});

// Switch layers on change from visible12 select
var layer14Object = $("#visible14");
layer14Object.on("change",function(){
	miscFuelPrice.setVisible(false);
	sorgFuelPrice.setVisible(false);
	stovFuelPrice.setVisible(false);
	swgFuelPrice.setVisible(false);
	switch(layer14Object.val()){
		case "miscBFPrice":
			miscFuelPrice.setVisible(true);
			break;
		case "sgBFPrice":
			sorgFuelPrice.setVisible(true);
			break;
		case "cornstovBFPrice":
			stovFuelPrice.setVisible(true);
			break;
		case "swgBFPrice":
			swgFuelPrice.setVisible(true);
			break;
	}
});

//Turn off or on GridMet layers
var gridMetOff = $('input[name="gridMetOn"]');
console.log(gridMetOff);
$('#tmeanGMLegend').hide();
$('#tmeanGMTitle').hide();
$('#pcpnGMLegend').hide();
$('#pcpnGMTitle').hide();
$('#petGMLegend').hide();
$('#petGMTitle').hide();
gridMetOff.on("change", function(){
	$('#visible16').prop('disabled', true);
	$('#visible17').prop('disabled', true);
	tmeanGM.setVisible(false);
	$('#tmeanGMLegend').hide();
	$('#tmeanGMTitle').hide();
	pcpnGM.setVisible(false);
	$('#pcpnGMLegend').hide();
	$('#pcpnGMTitle').hide();
	petGM.setVisible(false);
	$('#petGMLegend').hide();
	$('#petGMTitle').hide();
	if(gridMetOff.prop('checked')==true){
		$('#visible16').prop('disabled', false);
		$('#visible17').prop('disabled', false);
		var layer16Value = $("#visible16").val();
		if(layer16Value == "tmean"){
			$('#tmeanGMLegend').show();
			$('#tmeanGMTitle').show();
			colorize(tmeanGMColorList,'tmeanGMLegend');
			var layer17Value = $("#visible17").val();
			tmeanGridMetLayer(layer17Value);
			tmeanGM.setVisible(true);
		}else if(layer16Value == "pet"){
			$('#petGMLegend').show();
			$('#petGMTitle').show();
			colorize(petGMColorList,'petGMLegend');
			var layer17Value = $("#visible17").val();
			petGridMetLayer(layer17Value);
			petGM.setVisible(true);
		}else if(layer16Value == "pet"){
			$('#petGMLegend').show();
			$('#petGMTitle').show();
			colorize(petGMColorList,'petGMLegend');
			var layer17Value = $("#visible17").val();
			petGridMetLayer(layer17Value);
			petGM.setVisible(true);
		}
	}
});

// Switch layers on change from visible16 select
var layer16Object = $("#visible16");
layer16Object.on("change",function(){
	$('#tmeanGMLegend').hide();
	$('#tmeanGMTitle').hide();
	$('#pcpnGMLegend').hide();
	$('#pcpnGMTitle').hide();
	$('#petGMLegend').hide();
	$('#petGMTitle').hide();
	tmeanGM.setVisible(false);
	pcpnGM.setVisible(false);
	petGM.setVisible(false);
	var layer17Value = $("#visible17").val();
	switch(layer16Object.val()){
		case "tmean":
			$('#tmeanGMLegend').show();
			$('#tmeanGMTitle').show();
			tmeanGridMetLayer(layer17Value);
			tmeanGM.setVisible(true);
			break;
		case "pcpn":
			$('#pcpnGMLegend').show();
			$('#pcpnGMTitle').show();
			colorize(pcpnGMColorList,'pcpnGMLegend');
			pcpnGridMetLayer(layer17Value);
			pcpnGM.setVisible(true);
			break;
		case "pet":
			$('#petGMLegend').show();
			$('#petGMTitle').show();
			colorize(petGMColorList,'petGMLegend');
			petGridMetLayer(layer17Value);
			petGM.setVisible(true);
			break;
	}
});

// Switch layers on change from visible17 select - GridMet Month
var layer17Object = $("#visible17");
layer17Object.on("change",function(){
	$('#tmeanGMLegend').hide();
	$('#tmeanGMTitle').hide();
	$('#pcpnGMLegend').hide();
	$('#pcpnGMTitle').hide();
	$('#petGMLegend').hide();
	$('#petGMTitle').hide();
	var layer16Value = $("#visible16").val();
	if(layer16Value == "tmean"){
		$('#tmeanGMLegend').show();
		$('#tmeanGMTitle').show();
		tmeanGridMetLayer(layer17Object.val());
		tmeanGM.setVisible(true);
	} else if (layer16Value == "pcpn"){
		$('#pcpnGMLegend').show();
		$('#pcpnGMTitle').show();
		pcpnGridMetLayer(layer17Object.val());
		pcpnGM.setVisible(true);
	} else if (layer16Value == "pet"){
		$('#petGMLegend').show();
		$('#petGMTitle').show();
		petGridMetLayer(layer17Object.val());
		petGM.setVisible(true);
	}
});

//Turn off or on GHG Abatement Cost by crop layer
var ghgAbateCostOff = $('input[name="ghgAbateCostOn"]');
$('#ghgAbateLegend').hide();
$('#ghgAbateTitle').hide();
ghgAbateCostOff.on("change", function(){
	$('#visible19').prop('disabled', true);
	miscGhgAbate.setVisible(false);
	ensorgGhgAbate.setVisible(false);
	cornstovGhgAbate.setVisible(false);
	swgGhgAbate.setVisible(false);
	$('#ghgAbateLegend').hide();
	$('#ghgAbateTitle').hide();
	if(ghgAbateCostOff.prop('checked')==true){
		$('#visible19').prop('disabled', false);
		$('#ghgAbateLegend').show();
		$('#ghgAbateTitle').show();
		colorize(ghgAbateColorList,'ghgAbateLegend');
		var layer19Value = $("#visible19").val();
		if(layer19Value == "miscGhgAbate"){
			miscGhgAbate.setVisible(true);
		}
		else if(layer19Value == "ensorgGhgAbate"){
			ensorgGhgAbate.setVisible(true);
		}
		else if(layer19Value == "cornstovGhgAbate"){
			cornstovGhgAbate.setVisible(true);
		}
		else if(layer19Value == "swgGhgAbate"){
			swgGhgAbate.setVisible(true);
		}
	}
});

// Switch layers on change from visible19 select
var layer19Object = $("#visible19");
layer19Object.on("change",function(){
	miscGhgAbate.setVisible(false);
	ensorgGhgAbate.setVisible(false);
	cornstovGhgAbate.setVisible(false);
	swgGhgAbate.setVisible(false);
	switch(layer19Object.val()){
		case "miscGhgAbate":
			miscGhgAbate.setVisible(true);
			break;
		case "ensorgGhgAbate":
			ensorgGhgAbate.setVisible(true);
			break;
		case "cornstovGhgAbate":
			cornstovGhgAbate.setVisible(true);
			break;
		case "swgGhgAbate":
			swgGhgAbate.setVisible(true);
			break;
	}
});

var sgGHGOff = $('input[name="sgGHGOn"]');
$('#sgGHGDesc').hide();
sgGHGOff.on("change", function(){
	sgGHGPoints.setVisible(false);
	$('#sgGHGDesc').hide();
	if(sgGHGOff.prop('checked')==true){
		sgGHGPoints.setVisible(true);
		$('#sgGHGDesc').show();
	}
});

// Add years to time series dropdown
// Maize AgroIBIS yield
var agIBISEndYr = 2021;
for (var i=1990; i<=agIBISEndYr; ++i){
	$('#visible15').append($('<option>',{
		value: i,
		text: i.toString()
	}));
}

// Add months to time series dropdown
// GridMet Climatologies
var GMEndMon = 12;
for (var i=1; i<=GMEndMon; ++i){
	$('#visible17').append($('<option>',{
		value: i,
		text: i.toString()
	}));
}
